<template>
  <div class="games-info">
    <div class="button-wrapper-top">
      <!--<b-button v-if="userData.userType === 'Admin' || userData.userType === 'Coach'" class="main-button"
        @click="openPlayerInjuryModal('playerInjuryModal')" size="lg" v-b-tooltip.hover
        title="Submit player injury report" variant="outline-success">
        <i class="bi bi-file-text" aria-hidden="true"></i>
      </b-button>

      <b-button v-if="userData.userType === 'Admin' || userData.userType === 'Coach'" size="lg" class="main-button"
        variant="outline-success" v-b-tooltip.hover
        @click="download_csv(allPlayerInjuryReports, 'player-Injury-Reports')" title="Export player injuries to csv">
        <i class="bi bi-download" aria-hidden="true"></i>
      </b-button>

      <b-button v-if="userData.userType === 'Admin' || userData.userType === 'Coach'" size="lg" class="main-button"
        variant="outline-success" v-b-tooltip.hover title="Email player injuries">
        <i class="bi bi-envelope" aria-hidden="true"></i>
      </b-button>-->
    </div>

    <!-- Season Selector -->
    <div class="season-selector-wrapper">
      <div class="season-selector">
        <b-button-group>
          <b-button :variant="selectedSeason === 'current' ? 'primary' : 'outline-primary'
            " @click="switchSeason('current')">
            Current Season ({{ getCurrentSeason().label }})
          </b-button>
          <b-button :variant="selectedSeason === 'last' ? 'primary' : 'outline-primary'" @click="switchSeason('last')">
            Last Season ({{ getLastSeason().label }})
          </b-button>
        </b-button-group>

        <!-- Comparison Toggle -->
        <div class="comparison-toggle-wrapper">
          <b-button :variant="comparisonMode ? 'success' : 'outline-success'" @click="toggleComparisonMode"
            class="comparison-toggle">
            <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
            {{ comparisonMode ? "Exit Comparison" : "Compare Seasons" }}
          </b-button>
        </div>
      </div>
    </div>

    <!-- Comparison Mode Indicator -->
    <div v-if="comparisonMode" class="comparison-active-indicator">
      <i class="bi bi-check-circle text-success" aria-hidden="true"></i>
      Comparison mode active - Viewing both seasons side by side
    </div>

    <!-- Season Comparison View -->
    <div v-if="comparisonMode" class="season-comparison-view">
      <div class="comparison-header">
        <h3>Season Comparison Analysis</h3>
      </div>

      <!-- Comparison Metrics Summary -->
      <div class="comparison-metrics">
        <div class="metric-card">
          <h4>Total Injuries</h4>
          <div class="metric-comparison">
            <div class="season-metric">
              <span class="season-label">Current</span>
              <span class="metric-value">{{
                activePlayerInjuryData.length
              }}</span>
            </div>
            <div class="trend-indicator">
              <span :class="injuryTrendClass">
                <i :class="injuryTrendIcon" aria-hidden="true"></i>
                {{ injuryTrendPercentage }}
              </span>
            </div>
            <div class="season-metric">
              <span class="season-label">Last</span>
              <span class="metric-value">{{
                lastSeasonPlayerInjuryData.length
              }}</span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <h4>Live Injuries</h4>
          <div class="metric-comparison">
            <div class="season-metric">
              <span class="season-label">Current</span>
              <span class="metric-value">{{
                activePlayerLiveInjuryData.length
              }}</span>
            </div>
            <div class="trend-indicator">
              <span :class="liveInjuryTrendClass">
                <i :class="liveInjuryTrendIcon" aria-hidden="true"></i>
                {{ liveInjuryTrendPercentage }}
              </span>
            </div>
            <div class="season-metric">
              <span class="season-label">Last</span>
              <span class="metric-value">{{
                lastSeasonPlayerLiveInjuryData.length
              }}</span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <h4>Recovery Rate</h4>
          <div class="metric-comparison">
            <div class="season-metric">
              <span class="season-label">Current</span>
              <span class="metric-value">{{ currentSeasonRecoveryRate }}%</span>
            </div>
            <div class="trend-indicator">
              <span :class="recoveryTrendClass">
                <i :class="recoveryTrendIcon" aria-hidden="true"></i>
                {{ recoveryTrendPercentage }}
              </span>
            </div>
            <div class="season-metric">
              <span class="season-label">Last</span>
              <span class="metric-value">{{ lastSeasonRecoveryRate }}%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Side-by-Side Comparison Tables -->
      <div class="side-by-side-comparison">
        <div class="season-column">
          <h4>Current Season ({{ getCurrentSeason().label }})</h4>

          <!-- Current Season Live Injuries -->
          <div class="comparison-section">
            <h5>Live Injuries ({{ activePlayerLiveInjuryData.length }})</h5>
            <div v-if="activePlayerLiveInjuryData.length > 0" class="comparison-table-wrapper">
              <table class="comparison-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Injury</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="injury in activePlayerLiveInjuryData" :key="injury.id">
                    <td>{{ formatDateForHuman(injury.created_date) }}</td>
                    <td>{{ injury.injury_type }}</td>
                    <td>{{ injury.injury_status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="empty-comparison">No live injuries</div>
          </div>

          <!-- Current Season Historic Injuries -->
          <div class="comparison-section">
            <h5>
              Historic Injuries ({{ activePlayerHistoricInjuryData.length }})
            </h5>
            <div v-if="activePlayerHistoricInjuryData.length > 0" class="comparison-table-wrapper">
              <table class="comparison-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Injury</th>
                    <th>Return Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="injury in activePlayerHistoricInjuryData" :key="injury.id">
                    <td>{{ formatDateForHuman(injury.created_date) }}</td>
                    <td>{{ injury.injury_type }}</td>
                    <td>{{ injury.return_time }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="empty-comparison">No historic injuries</div>
          </div>
        </div>

        <div class="season-column">
          <h4>Last Season ({{ getLastSeason().label }})</h4>

          <!-- Last Season Live Injuries -->
          <div class="comparison-section">
            <h5>Live Injuries ({{ lastSeasonPlayerLiveInjuryData.length }})</h5>
            <div v-if="lastSeasonPlayerLiveInjuryData.length > 0" class="comparison-table-wrapper">
              <table class="comparison-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Injury</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="injury in lastSeasonPlayerLiveInjuryData" :key="injury.id">
                    <td>{{ formatDateForHuman(injury.created_date) }}</td>
                    <td>{{ injury.injury_type }}</td>
                    <td>{{ injury.injury_status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="empty-comparison">No live injuries</div>
          </div>

          <!-- Last Season Historic Injuries -->
          <div class="comparison-section">
            <h5>
              Historic Injuries ({{
                lastSeasonPlayerHistoricInjuryData.length
              }})
            </h5>
            <div v-if="lastSeasonPlayerHistoricInjuryData.length > 0" class="comparison-table-wrapper">
              <table class="comparison-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Injury</th>
                    <th>Return Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="injury in lastSeasonPlayerHistoricInjuryData" :key="injury.id">
                    <td>{{ formatDateForHuman(injury.created_date) }}</td>
                    <td>{{ injury.injury_type }}</td>
                    <td>{{ injury.return_time }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="empty-comparison">No historic injuries</div>
          </div>
        </div>
      </div>
    </div>

    <section>
      <ul class="tabs">
        <li class="tab-item">
          <a :class="selectedTab === 'injury-tab' ? 'tab-link active' : 'tab-link'
            " @click="tabChange('selectedTab', 'injury-tab')" href="javascript:;">{{ selectedSeasonLabel }}
            Injuries</a>
        </li>
        <li class="tab-item">
          <a :class="selectedTab === 'reports-tab' ? 'tab-link active' : 'tab-link'
            " @click="tabChange('selectedTab', 'reports-tab')" href="javascript:;">{{ selectedSeasonLabel }}
            MSK Reports</a>
        </li>
        <li class="tab-item">
          <a :class="selectedTab === 'illness-tab' ? 'tab-link active' : 'tab-link'
            " @click="tabChange('selectedTab', 'illness-tab')" href="javascript:;">{{ selectedSeasonLabel }}
            Illnesses</a>
        </li>
        <li class="tab-item">
          <a :class="selectedTab === 'medical-treatments-tab'
            ? 'tab-link active'
            : 'tab-link'
            " @click="tabChange('selectedTab', 'medical-treatments-tab')" href="javascript:;">Medical Treatments</a>
        </li>
        <li class="tab-item" v-if="userData.userType === 'Admin'">
          <a :class="selectedTab === 'concussion-tab' ? 'tab-link active' : 'tab-link'"
            @click="tabChange('selectedTab', 'concussion-tab')" href="javascript:;">Concussion</a>
        </li>
      </ul>

      <div class="tabs-wrapper">
        <div class="tab-content no-flex" v-if="selectedTab === 'concussion-tab' && userData.userType === 'Admin'">
          <ConcussionAssessment
            :player-id="selectedUserValue"
            :club-id="userData.clubId"
            :user-data="userData"
          />
        </div>
        <div class="tab-content no-flex" v-if="selectedTab === 'injury-tab'">
          <div class="button-wrapper-top">
            <b-button v-if="
              (userData.userType === 'Admin' || userData.userType === 'Coach') && !$store.getters.isReadOnlySeason
            " class="main-button" @click="openPlayerInjuryModal('playerInjuryModal')" size="lg" v-b-tooltip.hover
              title="Submit player injury report" variant="outline-success">
              <i class="bi bi-file-text" aria-hidden="true"></i>
            </b-button>
          </div>

          <!-- Loading state -->
          <div v-if="loadingLastSeason && selectedSeason === 'last'" class="text-center loading-state">
            <div class="loading-spinner"></div>
            <p>Loading {{ selectedSeasonLabel }} data...</p>
          </div>

          <div class="injury-section live-injuries">
            <div class="section-header">
              <div class="header-title">
                <i class="bi bi-bandaid"></i>
                <h3>Live Injuries</h3>
                <span class="badge-count danger" v-if="activePlayerLiveInjuryData.length > 0">
                  {{ activePlayerLiveInjuryData.length }}
                </span>
              </div>
              <span class="season-label">{{ selectedSeasonLabel }}</span>
            </div>

            <div v-if="activePlayerLiveInjuryData.length > 0" class="injury-content">
              <!-- Desktop Table View -->
              <div class="injury-table-wrapper desktop-only">
                <table class="injury-table modern">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Injury</th>
                      <th>Return</th>
                      <th>Treatment</th>
                      <th>Status</th>
                      <th v-if="isAdminOrCoach">RTP</th>
                      <th>Details</th>
                      <th v-if="isAdminOrCoach">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="injury in activePlayerLiveInjuryData" :key="injury.id"
                      :class="injury.injury_status === 'Fully recoverd' ? 'full-recoverd' : ''">
                      <td>{{ formatDateForHuman(injury.created_date) }}</td>
                      <td>{{ injury.injury_type }}</td>
                      <td>{{ injury.return_time }}</td>
                      <td class="injury-status">
                        <span :class="setInjuryStatusClass(injury.injury_status)">
                          <i :class="`bi ${getInjuryStatusIcon(injury.injury_status)}`" aria-hidden="true"></i>
                          {{ injury.injury_status }}
                        </span>
                      </td>
                      <td>
                        <span class="playing-training-status text-danger" v-if="injury.playing_status == 0">
                          <i class="bi bi-exclamation-circle" aria-hidden="true"></i> Can't play
                        </span>
                        <span class="playing-training-status text-success" v-else>
                          <i class="bi bi-check-circle" aria-hidden="true"></i> Ready to play
                        </span>
                        <span class="playing-training-status text-danger" v-if="injury.training_status === 'Unable'">
                          <i class="bi bi-exclamation-circle" aria-hidden="true"></i> Unable to train
                        </span>
                        <span class="playing-training-status text-warning"
                          v-else-if="injury.training_status === 'Partially'">
                          <i class="bi bi-exclamation-circle" aria-hidden="true"></i> Can partially train
                        </span>
                        <span class="playing-training-status text-success" v-else>
                          <i class="bi bi-check-circle" aria-hidden="true"></i> Can fully train
                        </span>
                      </td>
                      <td v-if="isAdminOrCoach" class="rtp-column">
                        <span v-if="injury.rtp_phase" class="badge" :class="'rtp-phase-' + injury.rtp_phase">P{{
                          injury.rtp_phase }}</span>
                        <b-button v-else size="sm" variant="outline-primary" @click="openStartRTPModal(injury)"
                          v-b-tooltip.hover title="Start RTP Protocol">
                          <i class="bi bi-activity" aria-hidden="true"></i>
                        </b-button>
                      </td>
                      <td class="injury-reports-wrapper">
                        <b-button @click="showAllInjuryReports(injury)" variant="outline-success" v-b-tooltip.hover
                          title="Detailed Reports">
                          <i class="bi bi-journal-medical" aria-hidden="true"></i>
                        </b-button>
                      </td>
                      <td v-if="isAdminOrCoach">
                        <div class="buttons-wrapper">
                          <b-button @click="editInjuryModal('editPlayerInjuryModal', injury)" variant="outline-warning">
                            <i class="bi bi-pencil" aria-hidden="true"></i> Edit
                          </b-button>
                          <b-button v-if="!$store.getters.isReadOnlySeason" @click="deletePlayerInjuryReport(injury.id)" variant="outline-danger">
                            <i class="bi bi-trash" aria-hidden="true"></i> Delete
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Mobile Card View -->
              <div class="injury-cards-wrapper mobile-only">
                <div v-for="injury in activePlayerLiveInjuryData" :key="'mobile-' + injury.id" class="injury-card"
                  :class="{ 'recovered': injury.injury_status === 'Fully recoverd' }">
                  <div class="injury-card-header">
                    <div class="injury-type-badge">
                      <i class="bi bi-bandaid"></i>
                      {{ injury.injury_type }}
                    </div>
                    <span :class="['status-pill', setInjuryStatusClass(injury.injury_status)]">
                      {{ injury.injury_status }}
                    </span>
                  </div>

                  <div class="injury-card-body">
                    <div class="injury-info-row">
                      <div class="info-item">
                        <span class="info-label"><i class="bi bi-calendar3"></i> Date</span>
                        <span class="info-value">{{ formatDateForHuman(injury.created_date) }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label"><i class="bi bi-clock"></i> Return</span>
                        <span class="info-value">{{ injury.return_time || 'TBD' }}</span>
                      </div>
                    </div>

                    <div class="status-tags">
                      <span class="status-tag" :class="injury.playing_status == 0 ? 'danger' : 'success'">
                        <i :class="injury.playing_status == 0 ? 'bi bi-x-circle' : 'bi bi-check-circle'"></i>
                        {{ injury.playing_status == 0 ? "Can't play" : 'Ready to play' }}
                      </span>
                      <span class="status-tag"
                        :class="injury.training_status === 'Unable' ? 'danger' : (injury.training_status === 'Partially' ? 'warning' : 'success')">
                        <i
                          :class="injury.training_status === 'Unable' ? 'bi bi-x-circle' : (injury.training_status === 'Partially' ? 'bi bi-exclamation-circle' : 'bi bi-check-circle')"></i>
                        {{ injury.training_status === 'Unable' ? 'Unable to train' : (injury.training_status ===
                          'Partially' ? 'Partial training' : 'Full training') }}
                      </span>
                    </div>

                    <div v-if="isAdminOrCoach && injury.rtp_phase" class="rtp-badge-mobile">
                      <span class="badge" :class="'rtp-phase-' + injury.rtp_phase">RTP Phase {{ injury.rtp_phase
                        }}</span>
                    </div>
                  </div>

                  <div class="injury-card-actions">
                    <button class="action-btn primary" @click="showAllInjuryReports(injury)">
                      <i class="bi bi-journal-medical"></i> Details
                    </button>
                    <button v-if="isAdminOrCoach && !injury.rtp_phase" class="action-btn info"
                      @click="openStartRTPModal(injury)">
                      <i class="bi bi-activity"></i> Start RTP
                    </button>
                    <button v-if="isAdminOrCoach" class="action-btn warning"
                      @click="editInjuryModal('editPlayerInjuryModal', injury)">
                      <i class="bi bi-pencil"></i> Edit
                    </button>
                    <button v-if="isAdminOrCoach" class="action-btn danger"
                      @click="deletePlayerInjuryReport(injury.id)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state-card">
              <div class="empty-icon success">
                <i class="bi bi-check-circle"></i>
              </div>
              <h4>No Active Injuries</h4>
              <p>This player currently has no live injuries</p>
            </div>
          </div>

          <div class="injury-section historic-injuries">
            <div class="section-header">
              <div class="header-title">
                <i class="bi bi-clock-history"></i>
                <h3>Injury History</h3>
                <span class="badge-count muted" v-if="activePlayerHistoricInjuryData.length > 0">
                  {{ activePlayerHistoricInjuryData.length }}
                </span>
              </div>
              <span class="season-label">{{ selectedSeasonLabel }}</span>
            </div>

            <div v-if="activePlayerHistoricInjuryData.length > 0" class="injury-content">
              <!-- Desktop Table View -->
              <div class="injury-table-wrapper desktop-only">
                <table class="injury-table modern">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Injury</th>
                      <th>Return</th>
                      <th>Status</th>
                      <th v-if="isAdminOrCoach">Details</th>
                      <th v-if="isAdminOrCoach">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="injury in activePlayerHistoricInjuryData" :key="injury.id"
                      :class="injury.injury_status === 'Fully recoverd' ? 'full-recoverd' : ''">
                      <td>{{ formatDateForHuman(injury.created_date) }}</td>
                      <td>{{ injury.injury_type }}</td>
                      <td>{{ injury.return_time }}</td>
                      <td class="injury-status">
                        <span :class="setInjuryStatusClass(injury.injury_status)">
                          <i :class="`bi ${getInjuryStatusIcon(injury.injury_status)}`" aria-hidden="true"></i>
                          {{ injury.injury_status }}
                        </span>
                      </td>
                      <td v-if="isAdminOrCoach" class="injury-reports-wrapper">
                        <b-button @click="showAllInjuryReports(injury)" variant="outline-success" v-b-tooltip.hover
                          title="Detailed Reports">
                          <i class="bi bi-journal-medical" aria-hidden="true"></i>
                        </b-button>
                      </td>
                      <td v-if="isAdminOrCoach">
                        <div class="buttons-wrapper">
                          <b-button @click="editInjuryModal('editPlayerInjuryModal', injury)" variant="outline-warning">
                            <i class="bi bi-pencil" aria-hidden="true"></i> Edit
                          </b-button>
                          <b-button v-if="!$store.getters.isReadOnlySeason" @click="deletePlayerInjuryReport(injury.id)" variant="outline-danger">
                            <i class="bi bi-trash" aria-hidden="true"></i> Delete
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Mobile Card View -->
              <div class="injury-cards-wrapper mobile-only">
                <div v-for="injury in activePlayerHistoricInjuryData" :key="'mobile-historic-' + injury.id"
                  class="injury-card historic" :class="{ 'recovered': injury.injury_status === 'Fully recoverd' }">
                  <div class="injury-card-header">
                    <div class="injury-type-badge">
                      <i class="bi bi-clock-history"></i>
                      {{ injury.injury_type }}
                    </div>
                    <span :class="['status-pill', setInjuryStatusClass(injury.injury_status)]">
                      {{ injury.injury_status }}
                    </span>
                  </div>

                  <div class="injury-card-body">
                    <div class="injury-info-row">
                      <div class="info-item">
                        <span class="info-label"><i class="bi bi-calendar3"></i> Date</span>
                        <span class="info-value">{{ formatDateForHuman(injury.created_date) }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label"><i class="bi bi-clock"></i> Return</span>
                        <span class="info-value">{{ injury.return_time || 'N/A' }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="injury-card-actions">
                    <button class="action-btn primary" @click="showAllInjuryReports(injury)">
                      <i class="bi bi-journal-medical"></i> Details
                    </button>
                    <button v-if="isAdminOrCoach" class="action-btn warning"
                      @click="editInjuryModal('editPlayerInjuryModal', injury)">
                      <i class="bi bi-pencil"></i> Edit
                    </button>
                    <button v-if="isAdminOrCoach" class="action-btn danger"
                      @click="deletePlayerInjuryReport(injury.id)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="injury-summary-section">
                <injury-body-chart :playerInjuryData="playerInjuryData" />

                <div class="injury-type-summary">
                  <h4><i class="bi bi-bar-chart"></i> Injury Breakdown</h4>
                  <ul class="injury-type-list">
                    <li v-for="(amount, type) in playerInjuryHistoryAmounts" :key="type">
                      <span class="injury-type-name">{{ type.replace(/([A-Z])/g, " $1") }}</span>
                      <span class="injury-type-count">{{ amount }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-else class="empty-state-card">
              <div class="empty-icon muted">
                <i class="bi bi-clipboard-check"></i>
              </div>
              <h4>No Injury History</h4>
              <p>No historic injuries recorded for this season</p>
            </div>
          </div>
        </div>

        <div class="tab-content no-flex" v-if="selectedTab === 'reports-tab'">
          <div class="button-wrapper-top">
            <b-button v-if="isAdminOrCoach" class="main-button" @click="createNewMSKreport()" size="lg"
              v-b-tooltip.hover title="Submit player MSK report" variant="outline-success">
              <i class="bi bi-file-text" aria-hidden="true"></i>
            </b-button>
          </div>

          <!--<div class="document-upload-physio-report">
            <DocumentUploader @getDocumentUploadsCall="getDocumentUploadsCall" documentCategory="msk-report"
              :club_id="userData.clubId" :user_id="selectedUserData.id"
              :selectedDocumentData="{ category: 'msk-report' }" />
          </div>-->

          <!-- MSK Dashboard -->
          <div class="msk-dashboard" v-if="mskDashboardData">
            <div class="dashboard-header">
              <h3><i class="bi bi-speedometer2"></i> MSK Assessment Dashboard</h3>
              <span class="assessment-date">
                Latest Assessment: {{ formatDateForHuman(mskDashboardData.assessmentDate) }}
                <span class="report-count">({{ mskDashboardData.totalReports }} total reports)</span>
              </span>
            </div>

            <!-- Overview Cards -->
            <div class="dashboard-overview">
              <div class="overview-card overall-score">
                <div class="card-icon">
                  <i class="bi bi-heart-pulse"></i>
                </div>
                <div class="card-content">
                  <span class="card-label">Overall ROM Score</span>
                  <span class="card-value"
                    :class="mskOverallScore >= 80 ? 'good' : (mskOverallScore >= 60 ? 'warning' : 'danger')">
                    {{ mskOverallScore }}%
                  </span>
                </div>
                <div class="score-bar">
                  <div class="score-fill" :style="{ width: mskOverallScore + '%' }"
                    :class="mskOverallScore >= 80 ? 'good' : (mskOverallScore >= 60 ? 'warning' : 'danger')"></div>
                </div>
              </div>

              <div class="overview-card special-tests">
                <div class="card-icon">
                  <i class="bi bi-clipboard2-check"></i>
                </div>
                <div class="card-content">
                  <span class="card-label">Special Tests</span>
                  <span class="card-value" :class="mskPositiveTestsCount.positive === 0 ? 'good' : 'danger'">
                    {{ mskPositiveTestsCount.positive }} / {{ mskPositiveTestsCount.total }}
                  </span>
                  <span class="card-sublabel">Positive findings</span>
                </div>
              </div>

              <div class="overview-card medical-history">
                <div class="card-icon">
                  <i class="bi bi-file-medical"></i>
                </div>
                <div class="card-content">
                  <span class="card-label">Medical History</span>
                  <span class="card-text">{{ mskDashboardData.medicalHistory }}</span>
                </div>
              </div>

              <div class="overview-card previous-injuries">
                <div class="card-icon">
                  <i class="bi bi-bandaid"></i>
                </div>
                <div class="card-content">
                  <span class="card-label">Previous Injuries</span>
                  <span class="card-text">{{ mskDashboardData.previousInjuries }}</span>
                </div>
              </div>
            </div>

            <!-- Joint Sections -->
            <div class="joint-sections">
              <!-- Hip Section -->
              <div class="joint-card">
                <div class="joint-header hip">
                  <i class="bi bi-person-walking"></i>
                  <h4>Hip Joint</h4>
                </div>
                <div class="joint-content">
                  <div class="rom-section">
                    <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                    <div class="rom-grid">
                      <div class="rom-item" v-for="(data, movement) in mskDashboardData.hip.rom"
                        :key="'hip-rom-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">
                            L: {{ data.left }}°
                            <i v-if="data.leftTrend !== null" :class="getTrendIcon(data.leftTrend)"></i>
                          </span>
                          <span class="value-cell" :class="data.rightStatus">
                            R: {{ data.right }}°
                            <i v-if="data.rightTrend !== null" :class="getTrendIcon(data.rightTrend)"></i>
                          </span>
                          <span class="normal-value">(Normal: {{ data.normal }}°)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mmt-section">
                    <h5><i class="bi bi-lightning"></i> Manual Muscle Testing (MMT)</h5>
                    <div class="mmt-grid">
                      <div class="mmt-item" v-for="(data, movement) in mskDashboardData.hip.mmt"
                        :key="'hip-mmt-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">L: {{ data.left }}</span>
                          <span class="value-cell" :class="data.rightStatus">R: {{ data.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tests-section">
                    <h5><i class="bi bi-check2-square"></i> Special Tests</h5>
                    <div class="tests-grid">
                      <div class="test-item" v-for="test in mskDashboardData.hip.specialTests"
                        :key="'hip-test-' + test.name">
                        <span class="test-name">{{ test.name }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="test.leftStatus">L: {{ test.left }}</span>
                          <span class="value-cell" :class="test.rightStatus">R: {{ test.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Knee Section -->
              <div class="joint-card">
                <div class="joint-header knee">
                  <i class="bi bi-circle-half"></i>
                  <h4>Knee Joint</h4>
                </div>
                <div class="joint-content">
                  <div class="rom-section">
                    <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                    <div class="rom-grid">
                      <div class="rom-item" v-for="(data, movement) in mskDashboardData.knee.rom"
                        :key="'knee-rom-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">
                            L: {{ data.left }}°
                            <i v-if="data.leftTrend !== null" :class="getTrendIcon(data.leftTrend)"></i>
                          </span>
                          <span class="value-cell" :class="data.rightStatus">
                            R: {{ data.right }}°
                            <i v-if="data.rightTrend !== null" :class="getTrendIcon(data.rightTrend)"></i>
                          </span>
                          <span class="normal-value">(Normal: {{ data.normal }}°)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mmt-section">
                    <h5><i class="bi bi-lightning"></i> Manual Muscle Testing (MMT)</h5>
                    <div class="mmt-grid">
                      <div class="mmt-item" v-for="(data, movement) in mskDashboardData.knee.mmt"
                        :key="'knee-mmt-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">L: {{ data.left }}</span>
                          <span class="value-cell" :class="data.rightStatus">R: {{ data.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tests-section">
                    <h5><i class="bi bi-check2-square"></i> Special Tests</h5>
                    <div class="tests-grid">
                      <div class="test-item" v-for="test in mskDashboardData.knee.specialTests"
                        :key="'knee-test-' + test.name">
                        <span class="test-name">{{ test.name }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="test.leftStatus">L: {{ test.left }}</span>
                          <span class="value-cell" :class="test.rightStatus">R: {{ test.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Ankle Section -->
              <div class="joint-card">
                <div class="joint-header ankle">
                  <i class="bi bi-arrow-down-circle"></i>
                  <h4>Ankle Joint</h4>
                </div>
                <div class="joint-content">
                  <div class="rom-section">
                    <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                    <div class="rom-grid">
                      <div class="rom-item" v-for="(data, movement) in mskDashboardData.ankle.rom"
                        :key="'ankle-rom-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">
                            L: {{ data.left }}°
                            <i v-if="data.leftTrend !== null" :class="getTrendIcon(data.leftTrend)"></i>
                          </span>
                          <span class="value-cell" :class="data.rightStatus">
                            R: {{ data.right }}°
                            <i v-if="data.rightTrend !== null" :class="getTrendIcon(data.rightTrend)"></i>
                          </span>
                          <span class="normal-value">(Normal: {{ data.normal }}°)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mmt-section">
                    <h5><i class="bi bi-lightning"></i> Manual Muscle Testing (MMT)</h5>
                    <div class="mmt-grid">
                      <div class="mmt-item" v-for="(data, movement) in mskDashboardData.ankle.mmt"
                        :key="'ankle-mmt-' + movement">
                        <span class="movement-name">{{ formatMovementName(movement) }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="data.leftStatus">L: {{ data.left }}</span>
                          <span class="value-cell" :class="data.rightStatus">R: {{ data.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tests-section">
                    <h5><i class="bi bi-check2-square"></i> Special Tests</h5>
                    <div class="tests-grid">
                      <div class="test-item" v-for="test in mskDashboardData.ankle.specialTests"
                        :key="'ankle-test-' + test.name">
                        <span class="test-name">{{ test.name }}</span>
                        <div class="values-row">
                          <span class="value-cell" :class="test.leftStatus">L: {{ test.left }}</span>
                          <span class="value-cell" :class="test.rightStatus">R: {{ test.right }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="MSK-report">
            <h3>MSK Injury Reports - {{ selectedSeasonLabel }}</h3>

            <table class="w-a-style injury-table" v-if="activeMskReportData.length > 0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>View report</th>
                  <th v-if="isAdminOrCoach">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="report in activeMskReportData" :key="report.id">
                  <td>{{ formatDateForHuman(report.assessment_date) }}</td>
                  <td class="injury-reports-wrapper" v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-button @click="viewMSKReport(report)" variant="outline-success" v-b-tooltip.hover
                      title="Detailed Reports">
                      <i class="bi bi-journal-medical" aria-hidden="true"></i></b-button>
                  </td>
                  <td v-if="isAdminOrCoach">
                    <div class="buttons-wrapper">
                      <b-button @click="createNewMSKreport(report)" variant="outline-warning">
                        <i class="bi bi-pencil" aria-hidden="true"></i>
                        Edit
                      </b-button>
                      <b-button v-if="!$store.getters.isReadOnlySeason" @click="deleteMSKReport(report.id)" variant="outline-danger">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                        Delete
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="empty-state">
              <img src="./img/emptyStateIllustration.svg" />
              <p>No MSK in app Injury Reports</p>
            </div>
          </div>

          <div class="mskReportPDFDocuments">
            <h3>MSK Injury Report PDF</h3>
            <table class="w-a-style injury-table" v-if="mskReportDocuments.length > 0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>PDF</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="reportPDF in mskReportDocuments" :key="reportPDF.id">
                  <td>{{ formatDateForHuman(reportPDF.created_date) }}</td>
                  <td>
                    <a target="_blank" :href="reportPDF.url">{{
                      removeNumberFromStart(reportPDF.name)
                    }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="empty-state">
              <img src="./img/emptyStateIllustration.svg" />
              <p>No MSK Injury Report PDFs</p>
            </div>
          </div>
        </div>

        <div class="tab-content no-flex" v-if="selectedTab === 'illness-tab'">
          <div class="button-wrapper-top">
            <b-button v-if="isAdminOrCoach" class="main-button" @click="createNewIllnessReport()" size="lg"
              v-b-tooltip.hover title="Submit player illness report" variant="outline-success">
              <i class="bi bi-file-text" aria-hidden="true"></i>
            </b-button>
          </div>

          <div class="illness-report">
            <h3>Player Illness Reports - {{ selectedSeasonLabel }}</h3>

            <table class="w-a-style injury-table" v-if="activeIllnessReportData.length > 0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Status</th>
                  <th>View report</th>
                  <th v-if="isAdminOrCoach">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="report in activeIllnessReportData" :key="report.id">
                  <td>{{ formatDateForHuman(report.created_at) }}</td>
                  <td>{{ report.status }}</td>
                  <td class="injury-reports-wrapper" v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-button @click="viewllnessReport(report)" variant="outline-success" v-b-tooltip.hover
                      title="Detailed Reports">
                      <i class="bi bi-journal-medical" aria-hidden="true"></i></b-button>
                  </td>
                  <td v-if="isAdminOrCoach">
                    <div class="buttons-wrapper">
                      <b-button @click="editIllnessReport(report)" variant="outline-warning">
                        <i class="bi bi-pencil" aria-hidden="true"></i>
                        Edit
                      </b-button>
                      <b-button v-if="!$store.getters.isReadOnlySeason" @click="deleteIllnessReport(report.id)" variant="outline-danger">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                        Delete
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="empty-state">
              <img src="./img/emptyStateIllustration.svg" />
              <p>No Player Illness Reports</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal v-if="showPlayerInjuryModal" v-model="showPlayerInjuryModal" size="xl" title="Record Player injury report"
      :hide-footer="true" @hide="hidePlayerInjuryReportModel()">
      <form class="form" @submit.prevent="savePlayerInjuryReport()">
        <div class="form__item">
          <label class="form__label" for="injury_type">Injury type</label>

          <select id="injury_type" v-model="newInjuryInformation.injury_type">
            <option value="Left ankle injury">Left ankle injury</option>
            <option value="Right ankle injury">Right ankle injury</option>
            <option value="Left Knee injury">Left Knee injury</option>
            <option value="Right Knee injury">Right Knee injury</option>
            <option value="Left Quad injury">Left Quad injury</option>
            <option value="Right Quad injury">Right Quad injury</option>
            <option value="Left hamstring injury">Left hamstring injury</option>
            <option value="Right hamstring injury">
              Right hamstring injury
            </option>
            <option value="Left groin injury">Left groin injury</option>
            <option value="Right groin injury">Right groin injury</option>
            <option value="Right Hip injury">Right Hip injury</option>
            <option value="Left Hip injury">Left Hip injury</option>
            <option value="Right Shoulder injury">Right Shoulder injury</option>
            <option value="Left Shoulder injury">Left Shoulder injury</option>
            <option value="Right Wrist and hand injury">
              Right Wrist and hand injury
            </option>
            <option value="Left Wrist and hand injury">
              Left Wrist and hand injury
            </option>
            <option value="Head injury">Head injury</option>
            <option value="Left foot injury">Left foot injury</option>
            <option value="Right foot injury">Right foot injury</option>
            <option value="Right arm injury">Right arm injury</option>
            <option value="Left arm injury">Left arm injury</option>
            <option value="Left calf injury">Left calf injury</option>
            <option value="Right calf injury">Right calf injury</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="activity_at_time">Type of activity at time of injury</label>
          <select id="activity_at_time" v-model="newInjuryInformation.activity_at_time">
            <option value="Training/practice for club">
              Training/practice for club
            </option>
            <option value="Game for club">Game for club</option>
            <option value="Training/practice not for club">
              Training/practice not for club
            </option>
            <option value="Game not for club">Game not for club</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="reasion_for_presentation">Reason for Presentation</label>
          <select id="reasion_for_presentation" v-model="newInjuryInformation.reasion_for_presentation">
            <option value="New injury">New injury</option>
            <option value="exacerbated/aggravated injury">
              Exacerbated/aggravated injury
            </option>
            <option value="recurrent injury">Recurrent injury</option>
            <option value="Continuation of treatment">
              Continuation of treatment
            </option>
            <option value="Left hamstring injury">Other</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="more_detail">Details of injury</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('more_detail', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'more_detail' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "more_detail" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="more_detail" v-model="newInjuryInformation.more_detail"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="diagnosis">Diagnosis</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('diagnosis', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'diagnosis' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "diagnosis" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="diagnosis" v-model="newInjuryInformation.diagnosis"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="treatment">Treatment plan</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('treatment', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'treatment' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "treatment" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="treatment" v-model="newInjuryInformation.treatment"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="return_time">Return time</label>
          <select id="return_time" v-model="newInjuryInformation.return_time">
            <option value="1 - 2 days">1 - 2 days</option>
            <option value="3 - 5 days">3 - 5 days</option>
            <option value="1 week">1 week</option>
            <option value="2 - 3 weeks">2 - 3 weeks</option>
            <option value="A month">A month</option>
            <option value="A few months">A few months</option>
            <option value="Phased return">Phased return</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="injury_status">Injury Status</label>
          <select id="injury_status" v-model="newInjuryInformation.injury_status">
            <option value="Reciving treatment">Reciving treatment</option>
            <option value="Resting">Resting</option>
            <option value="Phased return">Phased return</option>
            <option value="Light training">
              Light training ( return to fitness plan )
            </option>
            <option value="Fully recoverd">Fully recoverd</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="playing_status">Playing Status</label>
          <p>Available to play?</p>
          <b-form-group id="playing_status">
            <div class="radio-box-group">
              <label class="radio-box green" :class="{ selected: newInjuryInformation.playing_status == 1 }">
                <b-form-radio v-model="newInjuryInformation.playing_status" name="playing_status-radios"
                  value="1"></b-form-radio>
                <span>Yes</span>
              </label>
              <label class="radio-box red" :class="{ selected: newInjuryInformation.playing_status == 0 }">
                <b-form-radio v-model="newInjuryInformation.playing_status" name="playing_status-radios"
                  value="0"></b-form-radio>
                <span>No</span>
              </label>
            </div>
          </b-form-group>
        </div>

        <div class="form__item">
          <label class="form__label" for="playing_status">Training Status</label>
          <b-form-group id="playing_status">
            <div class="radio-box-group">
              <label class="radio-box green" :class="{
                selected: newInjuryInformation.training_status === 'Fully',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Fully"></b-form-radio>
                <span>Can Fully train</span>
              </label>
              <label class="radio-box amber" :class="{
                selected:
                  newInjuryInformation.training_status === 'Partially',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Partially"></b-form-radio>
                <span>Can Partially train</span>
              </label>
              <label class="radio-box red" :class="{
                selected: newInjuryInformation.training_status === 'Unable',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Unable"></b-form-radio>
                <span>Unable to train</span>
              </label>
            </div>
          </b-form-group>
        </div>

        <div class="form__item">
          <label for="physio-select">Physio</label>
          <div class="physio-select">
            <select id="physio-select" v-model="newInjuryInformation.physio_id">
              <option v-for="physio in allPhysios" :key="physio.id" :value="physio.id">
                {{ physio.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form__item">
          <label class="form__label" for="contact">Contact information / notes</label>
          <textarea class="form__input" type="text" id="contact" v-model="newInjuryInformation.contact" />
        </div>

        <b-button type="submit" size="lg" variant="outline-success" :disabled="$store.getters.isReadOnlySeason"><i class="bi bi-file-text" aria-hidden="true"></i>
          Submit player
          injury report</b-button>
      </form>
    </b-modal>

    <!-- Simplified Add Treatment Record Modal -->
    <b-modal v-if="showAddTreatmentModal" v-model="showAddTreatmentModal" size="lg" title="Add Treatment Record"
      :hide-footer="true">
      <div class="treatment-record-form">
        <div class="injury-context-banner">
          <div class="context-icon">
            <i class="bi bi-bandaid"></i>
          </div>
          <div class="context-info">
            <span class="injury-type">{{ selectedInjury?.injury_type }}</span>
            <span class="injury-date">Started: {{ formatDateForHuman(selectedInjury?.created_date) }}</span>
          </div>
        </div>

        <form class="form" @submit.prevent="saveTreatmentRecord()">
          <div class="form__item">
            <label class="form__label" for="treatment-notes-new">
              <i class="bi bi-journal-medical"></i>
              Treatment Details / Notes
            </label>
            <b-button class="voice-record-button" @click="toggleVoiceRecording('newTreatment', 'newTreatmentRecord')"
              variant="outline-danger" size="sm">
              <i :class="`bi ${isRecording === 'newTreatment' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
              {{ isRecording === 'newTreatment' ? 'Stop Recording' : 'Record Voice' }}
            </b-button>
            <textarea class="form-control" rows="6" id="treatment-notes-new" v-model="newTreatmentRecord.treatment"
              placeholder="Enter treatment details, observations, progress notes..."></textarea>
          </div>

          <div class="form__item">
            <label class="form__label" for="physio-select-new">
              <i class="bi bi-person-badge"></i>
              Assigned Physio
            </label>
            <select id="physio-select-new" class="form-select" v-model="newTreatmentRecord.physio_id">
              <option value="">Select a physio...</option>
              <option v-for="physio in allPhysios" :key="physio.id" :value="physio.id">
                {{ physio.name }}
              </option>
            </select>
          </div>

          <div class="form-actions">
            <b-button variant="outline-secondary" @click="showAddTreatmentModal = false">
              Cancel
            </b-button>
            <b-button type="submit" variant="success" :disabled="!newTreatmentRecord.treatment || $store.getters.isReadOnlySeason">
              <i class="bi bi-check-lg" aria-hidden="true"></i>
              Save Treatment Record
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal v-if="showEditPlayerInjuryModal" v-model="showEditPlayerInjuryModal" size="lg"
      title="Edit Player injury report" :hide-footer="true" @hide="hidePlayerInjuryReportModel()">
      <form class="form" @submit.prevent="updatePlayerInjuryInformation()">
        <div class="form__item">
          <label class="form__label" for="injury_type">Injury type</label>

          <select id="injury_type" v-model="newInjuryInformation.injury_type">
            <option value="Left ankle injury">Left ankle injury</option>
            <option value="Right ankle injury">Right ankle injury</option>
            <option value="Left Knee injury">Left Knee injury</option>
            <option value="Right Knee injury">Right Knee injury</option>
            <option value="Left Quad injury">Left Quad injury</option>
            <option value="Right Quad injury">Right Quad injury</option>
            <option value="Left hamstring injury">Left hamstring injury</option>
            <option value="Right hamstring injury">
              Right hamstring injury
            </option>
            <option value="Left groin injury">Left groin injury</option>
            <option value="Right groin injury">Right groin injury</option>
            <option value="Right Hip injury">Right Hip injury</option>
            <option value="Left Hip injury">Left Hip injury</option>
            <option value="Right Shoulder injury">Right Shoulder injury</option>
            <option value="Left Shoulder injury">Left Shoulder injury</option>
            <option value="Right Wrist and hand injury">
              Right Wrist and hand injury
            </option>
            <option value="Left Wrist and hand injury">
              Left Wrist and hand injury
            </option>
            <option value="Head injury">Head injury</option>
            <option value="Left foot injury">Left foot injury</option>
            <option value="Right foot injury">Right foot injury</option>
            <option value="Right arm injury">Right arm injury</option>
            <option value="Left arm injury">Left arm injury</option>
            <option value="Left calf injury">Left calf injury</option>
            <option value="Right calf injury">Right calf injury</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="reasion_for_presentation">Reason for Presentation</label>
          <select id="reasion_for_presentation" v-model="newInjuryInformation.reasion_for_presentation">
            <option value="New injury">New injury</option>
            <option value="exacerbated/aggravated injury">
              Exacerbated/aggravated injury
            </option>
            <option value="recurrent injury">Recurrent injury</option>
            <option value="Continuation of treatment">
              Continuation of treatment
            </option>
            <option value="Left hamstring injury">Other</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="activity_at_time">Type of activity at time of injury</label>
          <select id="activity_at_time" v-model="newInjuryInformation.activity_at_time">
            <option value="Training/practice for club">
              Training/practice for club
            </option>
            <option value="Game for club">Game for club</option>
            <option value="Training/practice not for club">
              Training/practice not for club
            </option>
            <option value="Game not for club">Game not for club</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="more_detail">Details of injury</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('more_detail', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'more_detail' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "more_detail" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="more_detail" v-model="newInjuryInformation.more_detail"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="diagnosis">Diagnosis</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('diagnosis', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'diagnosis' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "diagnosis" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="diagnosis" v-model="newInjuryInformation.diagnosis"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="treatment">Treatment plan</label>
          <b-button class="voice-record-button" @click="toggleVoiceRecording('treatment', 'newInjuryInformation')"
            variant="outline-danger">
            <i :class="`bi ${isRecording === 'treatment' ? 'bi-mic-fill' : 'bi-mic'}`" aria-hidden="true"></i>
            {{
              isRecording === "treatment" ? "Stop Recording" : "Record Voice"
            }}
          </b-button>
          <textarea class="form__input" id="treatment" v-model="newInjuryInformation.treatment"></textarea>
        </div>

        <div class="form__item">
          <label class="form__label" for="return_time">Return time</label>
          <select id="return_time" v-model="newInjuryInformation.return_time">
            <option value="1 - 2 days">1 - 2 days</option>
            <option value="3 - 5 days">3 - 5 days</option>
            <option value="1 week">1 week</option>
            <option value="2 - 3 weeks">2 - 3 weeks</option>
            <option value="A month">A month</option>
            <option value="A few months">A few months</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="injury_status">Injury Status</label>
          <select id="injury_status" v-model="newInjuryInformation.injury_status">
            <option value="Reciving treatment">Reciving treatment</option>
            <option value="Resting">Resting</option>
            <option value="Light training">
              Light training ( return to fitness plan )
            </option>
            <option value="Fully recoverd">Fully recoverd</option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="playing_status">Playing Status</label>
          <p>Available to play?</p>
          <b-form-group id="playing_status">
            <div class="radio-box-group">
              <label class="radio-box green" :class="{ selected: newInjuryInformation.playing_status == 1 }">
                <b-form-radio v-model="newInjuryInformation.playing_status" name="playing_status-radios"
                  value="1"></b-form-radio>
                <span>Yes</span>
              </label>
              <label class="radio-box red" :class="{ selected: newInjuryInformation.playing_status == 0 }">
                <b-form-radio v-model="newInjuryInformation.playing_status" name="playing_status-radios"
                  value="0"></b-form-radio>
                <span>No</span>
              </label>
            </div>
          </b-form-group>
        </div>

        <div class="form__item">
          <label class="form__label" for="playing_status">Training Status</label>
          <b-form-group id="playing_status">
            <div class="radio-box-group">
              <label class="radio-box green" :class="{
                selected: newInjuryInformation.training_status === 'Fully',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Fully"></b-form-radio>
                <span>Can Fully train</span>
              </label>
              <label class="radio-box amber" :class="{
                selected:
                  newInjuryInformation.training_status === 'Partially',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Partially"></b-form-radio>
                <span>Can Partially train</span>
              </label>
              <label class="radio-box red" :class="{
                selected: newInjuryInformation.training_status === 'Unable',
              }">
                <b-form-radio v-model="newInjuryInformation.training_status" name="playing_status-radios"
                  value="Unable"></b-form-radio>
                <span>Unable to train</span>
              </label>
            </div>
          </b-form-group>
        </div>

        <div class="form__item">
          <label class="form__label" for="contact">Contact information / notes</label>
          <textarea class="form__input" type="text" id="contact" v-model="newInjuryInformation.contact" />
        </div>

        <div class="form__item">
          <label for="physio-select">Physio</label>
          <div class="physio-select">
            <select id="physio-select" v-model="newInjuryInformation.physio_id">
              <option v-for="physio in allPhysios" :key="physio.id" :value="physio.id">
                {{ physio.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="documents" v-if="
          newInjuryInformation.player_document_id !== null ||
          newInjuryInformation.physio_document_id !== null
        ">
          <h4>Documents</h4>

          <div class="document" v-if="newInjuryInformation.player_document_id !== null" v-b-tooltip.hover
            title="Delete Player document" @click="
              removeUploadedDocument(newInjuryInformation.player_document_id)
              ">
            <img src="./img/documentlib.svg" />
            <h3>Player document</h3>
            <div class="doc-buttons">
              <i class="bi bi-trash" aria-hidden="true"></i>
            </div>
          </div>

          <div class="document" v-if="newInjuryInformation.physio_document_id !== null" v-b-tooltip.hover
            title="Delete Physio document" @click="
              removeUploadedDocument(newInjuryInformation.physio_document_id)
              ">
            <img src="./img/documentlib.svg" />
            <h3>Physio document</h3>
            <div class="doc-buttons">
              <i class="bi bi-trash" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <b-button type="submit" size="lg" variant="outline-success" :disabled="$store.getters.isReadOnlySeason"><i class="bi bi-file-text" aria-hidden="true"></i>
          Submit player
          injury report</b-button>
      </form>
    </b-modal>

    <b-modal v-if="showAllplayerInjuryReportsModal" v-model="showAllplayerInjuryReportsModal"
      modal-class="modal-fullscreen" size="xl" title="Player injury reports" :hide-footer="true">
      <div class="injury-modal-content">
        <!-- Player Header Card -->
        <div class="player-header-card">
          <div class="player-profile-section">
            <div class="player-avatar-wrapper">
              <template
                v-if="selectedUserData !== null && selectedUserData !== undefined && Object.keys(selectedUserData).length !== 0">
                <img v-if="selectedUserData.userImage !== '' && selectedUserData.userImage !== null"
                  :src="getImgUrl(selectedUserData.userImage)" alt="" class="player-avatar-lg" />
                <div v-else class="player-avatar-placeholder-lg">
                  {{selectedUserData.name ? selectedUserData.name.split(' ').map(n =>
                    n[0]).join('').toUpperCase().slice(0, 2) : '?'}}
                </div>
              </template>
            </div>
            <div class="player-info-section">
              <h2 class="player-name-title">{{ selectedUserData.name }}</h2>
              <p class="player-team-subtitle">{{ selectedUserData.age_group || selectedUserData.teamName }}</p>
            </div>
          </div>
          <div class="status-badges-section">
            <div class="status-badge-item"
              :class="selectedInjury.injury_status === 'Fully recoverd' ? 'status-recovered' : 'status-treating'">
              <i :class="`bi ${getInjuryStatusIcon(selectedInjury.injury_status)}`" aria-hidden="true"></i>
              <span>{{ selectedInjury.injury_status || 'Unknown' }}</span>
            </div>
            <div class="status-badge-item"
              :class="selectedInjury.playing_status == 0 ? 'status-danger' : 'status-success'">
              <i :class="selectedInjury.playing_status == 0 ? 'bi bi-x-circle' : 'bi bi-check-circle'"
                aria-hidden="true"></i>
              <span>{{ selectedInjury.playing_status == 0 ? "Can't play" : 'Ready to play' }}</span>
            </div>
            <div class="status-badge-item" :class="{
              'status-danger': selectedInjury.training_status === 'Unable',
              'status-warning': selectedInjury.training_status === 'Partially',
              'status-success': selectedInjury.training_status !== 'Unable' && selectedInjury.training_status !== 'Partially'
            }">
              <i :class="{
                'bi bi-x-circle': selectedInjury.training_status === 'Unable',
                'bi bi-exclamation-circle': selectedInjury.training_status === 'Partially',
                'bi bi-check-circle': selectedInjury.training_status !== 'Unable' && selectedInjury.training_status !== 'Partially'
              }" aria-hidden="true"></i>
              <span>{{ selectedInjury.training_status === 'Unable' ? 'Unable to train' : selectedInjury.training_status
                ===
                'Partially' ? 'Partial training' : 'Full training' }}</span>
            </div>
          </div>
        </div>

        <!-- Injury Details Section -->
        <div class="injury-details-section">
          <h4 class="section-title">
            <i class="bi bi-bandaid" aria-hidden="true"></i>
            Injury Information
          </h4>
          <div class="details-grid">
            <div class="detail-card">
              <div class="detail-icon"><i class="bi bi-bandaid-fill"></i></div>
              <div class="detail-content">
                <span class="detail-label">Injury Type</span>
                <span class="detail-value">{{ selectedInjury.injury_type || '-' }}</span>
              </div>
            </div>
            <div class="detail-card">
              <div class="detail-icon"><i class="bi bi-activity"></i></div>
              <div class="detail-content">
                <span class="detail-label">Activity at Time</span>
                <span class="detail-value">{{ selectedInjury.activity_at_time || '-' }}</span>
              </div>
            </div>
            <div class="detail-card">
              <div class="detail-icon"><i class="bi bi-calendar-event"></i></div>
              <div class="detail-content">
                <span class="detail-label">Return Time</span>
                <span class="detail-value">{{ selectedInjury.return_time || '-' }}</span>
              </div>
            </div>
            <div class="detail-card">
              <div class="detail-icon"><i class="bi bi-person-badge"></i></div>
              <div class="detail-content">
                <span class="detail-label">Physio</span>
                <span class="detail-value">{{ getPhysioName(selectedInjury.physio_id) || '-' }}</span>
              </div>
            </div>
            <div class="detail-card">
              <div class="detail-icon"><i class="bi bi-calendar-check"></i></div>
              <div class="detail-content">
                <span class="detail-label">Created Date</span>
                <span class="detail-value">{{ formatDateForHuman(selectedInjury.created_date) }}</span>
              </div>
            </div>
          </div>

          <!-- Text Areas -->
          <div class="text-details-grid" v-if="userData.userType !== 'User'">
            <div class="text-detail-card" v-if="selectedInjury.diagnosis">
              <h5><i class="bi bi-file-medical"></i> Diagnosis</h5>
              <p>{{ selectedInjury.diagnosis }}</p>
            </div>
            <div class="text-detail-card" v-if="selectedInjury.treatment">
              <h5><i class="bi bi-prescription2"></i> Treatment Plan</h5>
              <p>{{ selectedInjury.treatment }}</p>
            </div>
            <div class="text-detail-card" v-if="selectedInjury.more_detail">
              <h5><i class="bi bi-journal-text"></i> Additional Details</h5>
              <p>{{ selectedInjury.more_detail }}</p>
            </div>
          </div>
        </div>

        <!-- RTP Protocol Section -->
        <div class="rtp-protocol-section"
          style="margin-top: 1.5rem; padding: 1rem; background: #f8f9fa; border-radius: 8px;">
          <h4 style="margin-bottom: 1rem;">
            <i class="bi bi-activity" aria-hidden="true"></i>
            Return-to-Play Protocol
          </h4>

          <!-- Show Start RTP button if no RTP started and injury is not fully recovered -->
          <div v-if="!selectedInjury.rtp_phase && selectedInjury.injury_status !== 'Fully recoverd'"
            class="start-rtp-section">
            <p style="color: #666; margin-bottom: 1rem;">
              Start a Return-to-Play protocol to track the player's recovery journey through 5 structured phases.
            </p>
            <b-button @click="openStartRTPModal(selectedInjury)" variant="outline-primary" :disabled="startingRTP">
              <i class="bi bi-activity" aria-hidden="true"></i>
              Start RTP Protocol
            </b-button>
          </div>

          <!-- Show PlayerRTPView for players viewing their own injury -->
          <div v-else-if="selectedInjury.rtp_phase && isViewingOwnInjury">
            <PlayerRTPView :injuryId="selectedInjury.id" :playerId="selectedUserData.id" />
          </div>

          <!-- Show RTP Phase Tracker AND Player Insights for staff viewing other players' injuries -->
          <div v-else-if="selectedInjury.rtp_phase">
            <!-- Phase Tracker with management actions -->
            <RTPPhaseTracker :injuryId="selectedInjury.id" :userData="userData" :showActions="true"
              @phase-updated="onRTPPhaseUpdated" @rtp-completed="onRTPCompleted" />

            <!-- Player's RTP insights (compliance, exercises, activity) -->
            <div class="staff-rtp-insights"
              style="margin-top: 1.5rem; border-top: 1px solid #e9ecef; padding-top: 1.5rem;">
              <h5 style="margin-bottom: 1rem; color: #495057;">
                <i class="bi bi-graph-up" aria-hidden="true"></i>
                Player's RTP Progress & Exercises
              </h5>
              <PlayerRTPView :injuryId="selectedInjury.id" :playerId="selectedUserData.id" :hidePhaseProgress="true"
                :hideCurrentPhaseCard="true" />
            </div>
          </div>

          <!-- Show message if injury is fully recovered without RTP -->
          <div v-else class="text-muted">
            <p><i class="bi bi-check-circle text-success" aria-hidden="true"></i> This injury has been marked as fully
              recovered.</p>
          </div>
        </div>

        <!-- Physio Appointments Section -->
        <div class="physio-appointments-section"
          style="margin-top: 1.5rem; padding: 1rem; background: #f8f9fa; border-radius: 8px;">
          <div class="physio-appointments-header">
            <h4 style="margin-bottom: 0;">
              <i class="bi bi-calendar2-heart" aria-hidden="true"></i>
              Physio Appointments
            </h4>
            <router-link :to="{ name: 'bookPhysio' }" class="btn btn-sm btn-success">
              <i class="bi bi-plus"></i> Book Appointment
            </router-link>
          </div>

          <div v-if="physioAppointmentsLoading" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary"></div>
            <span class="ms-2">Loading appointments...</span>
          </div>

          <div v-else-if="playerPhysioAppointments.length === 0" class="empty-appointments-state">
            <i class="bi bi-calendar-x"></i>
            <p>No physio appointments booked for this player</p>
            <router-link :to="{ name: 'bookPhysio' }" class="btn btn-primary btn-sm">
              Book an Appointment
            </router-link>
          </div>

          <div v-else class="physio-appointments-list">
            <div v-for="apt in playerPhysioAppointments" :key="apt.id" class="physio-appointment-card"
              :class="apt.status">
              <div class="apt-date-badge">
                <span class="apt-day">{{ formatAppointmentDay(apt.appointment_date) }}</span>
                <span class="apt-month">{{ formatAppointmentMonth(apt.appointment_date) }}</span>
              </div>
              <div class="apt-details">
                <div class="apt-time">
                  <i class="bi bi-clock"></i>
                  {{ formatAppointmentTime(apt.start_time) }} - {{ formatAppointmentTime(apt.end_time) }}
                </div>
                <div class="apt-physio">
                  <i class="bi bi-person-badge"></i>
                  {{ apt.physio_name || 'Physio' }}
                </div>
                <div v-if="apt.reason" class="apt-reason">
                  <i class="bi bi-chat-text"></i>
                  {{ apt.reason }}
                </div>
              </div>
              <div class="apt-status-badge">
                <span class="status-badge" :class="apt.status">
                  {{ apt.status }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Documents Section -->
        <div class="documents-section" v-if="userData.userType !== 'User'">
          <h4 class="section-title">
            <i class="bi bi-folder2-open" aria-hidden="true"></i>
            Documents
          </h4>
          <div class="documents-content">
            <div class="document-upload-area">
              <DocumentUploader @getDocumentUploadsCall="getDocumentUploadsCall" documentCategory="physio-report"
                :club_id="userData.clubId" :user_id="selectedUserData.id" :elementData="editInjuryReport"
                :selectedDocumentData="{ category: 'physio-report' }" />
            </div>

            <div class="documents-list" v-if="reportDocuments.length > 0">
              <div v-for="physioDocument in reportDocuments" :key="physioDocument.id" class="document-card">
                <div class="doc-icon">
                  <i class="bi bi-file-earmark-medical"></i>
                </div>
                <div class="doc-info">
                  <span class="doc-name">{{ physioDocument.name }}</span>
                </div>
                <div class="doc-actions">
                  <a :href="getDocumentUrl(physioDocument.url)" target="_blank" class="doc-action-btn view" title="View">
                    <i class="bi bi-eye"></i>
                  </a>
                  <button class="doc-action-btn delete"
                    @click="removeUploadedDocument(physioDocument.id, physioDocument.name)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div v-else class="empty-documents">
              <i class="bi bi-folder2"></i>
              <p>No documents uploaded</p>
            </div>
          </div>
        </div>

        <!-- Action Button -->
        <div class="modal-actions" v-if="userData.userType !== 'User'">
          <button class="btn btn-primary" @click="editInjuryModal('editPlayerInjuryModal', selectedInjury)">
            <i class="bi bi-pencil-square" aria-hidden="true"></i> Edit Injury Report
          </button>
        </div>

        <!-- Attendance and Treatment Section -->
        <div class="attendance-section" v-if="userData.userType !== 'User'">
          <div class="attendance-header">
            <div class="attendance-title">
              <h4 class="section-title">
                <i class="bi bi-clipboard2-pulse" aria-hidden="true"></i>
                Attendance & Treatment Details
              </h4>
              <p class="attendance-description">Track each physio visit and treatment session for comprehensive injury
                management.</p>
            </div>
            <button v-if="!$store.getters.isReadOnlySeason" class="btn btn-success" @click="openAddTreatmentModal()">
              <i class="bi bi-plus-lg" aria-hidden="true"></i> Add Treatment Record
            </button>
          </div>

          <div class="attendance-content">
            <!-- Treatment Records Table -->
            <div class="treatment-records" v-if="selectedInjuryReports.length > 0">
              <table class="treatment-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Physio</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="injury in selectedInjuryReports" :key="injury.id"
                    :class="{ 'recovered-row': injury.injury_status === 'Fully recoverd' }">
                    <td>
                      <div class="date-cell">
                        <i class="bi bi-calendar3"></i>
                        {{ formatDateForHuman(injury.created_date) }}
                      </div>
                    </td>
                    <td>{{ getPhysioName(injury.physio_id) }}</td>
                    <td>
                      <span class="treatment-status-badge"
                        :class="injury.injury_status === 'Fully recoverd' ? 'recovered' : 'ongoing'">
                        {{ injury.injury_status || 'Ongoing' }}
                      </span>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary" @click="selectInjuryReportView(injury)"
                        title="View Details">
                        <i class="bi bi-eye" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="empty-treatments">
              <i class="bi bi-clipboard-x"></i>
              <p>No treatment records yet</p>
            </div>

            <!-- Selected Treatment Details -->
            <div class="treatment-details-panel" v-if="Object.keys(editInjuryReport).length !== 0">
              <div class="panel-header">
                <h5>
                  <i class="bi bi-journal-medical"></i>
                  Treatment Record - {{ formatDateForHuman(editInjuryReport.created_date) }}
                </h5>
              </div>
              <div class="panel-body">
                <div class="form-group">
                  <label for="treatment-notes">
                    Treatment Details / Notes
                    <button class="voice-btn" @click="toggleVoiceRecording('treatment', 'editInjuryReport')"
                      type="button">
                      <i :class="`bi ${isRecording === 'treatment' ? 'bi-mic-fill recording' : 'bi-mic'}`"
                        aria-hidden="true"></i>
                      {{ isRecording === "treatment" ? "Stop" : "Record" }}
                    </button>
                  </label>
                  <textarea class="form-control" rows="6" id="treatment-notes" v-model="editInjuryReport.treatment"
                    placeholder="Enter treatment details..."></textarea>
                </div>

                <div class="form-group">
                  <label for="physio-select-edit">Assigned Physio</label>
                  <select id="physio-select-edit" class="form-select" v-model="editInjuryReport.physio_id">
                    <option v-for="physio in allPhysios" :key="physio.id" :value="physio.id">
                      {{ physio.name }}
                    </option>
                  </select>
                </div>

                <button class="btn btn-primary" @click="updatePlayerInjuryReport(editInjuryReport)">
                  <i class="bi bi-check-lg" aria-hidden="true"></i> Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showMskReportModal" v-model="showMskReportModal" size="xl" modal-class="modal-fullscreen"
      title="Create New MSK Report" :hide-footer="true">
      <form class="form msk-form-improved" @submit.prevent="saveMSKReport">
        <!-- Player Info Header -->
        <div class="msk-player-header">
          <div class="player-info-compact">
            <i class="bi bi-person-circle"></i>
            <div>
              <strong>{{ selectedUserData.name }}</strong>
              <span class="team-badge">{{ selectedUserData.age_group }}</span>
            </div>
          </div>
          <div class="msk-progress-indicator">
            <span class="progress-label">Progress:</span>
            <div class="progress-bar-wrapper">
              <div class="progress-bar-fill" :style="{ width: mskCompletionPercent + '%' }"></div>
            </div>
            <span class="progress-percent">{{ mskCompletionPercent }}%</span>
          </div>
        </div>

        <!-- Quick Actions Bar -->
        <div class="msk-quick-actions">
          <b-button size="sm" variant="outline-primary" @click="fillNormalRanges()">
            <i class="bi bi-lightning"></i> Fill Normal Ranges
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="clearAllMSK()">
            <i class="bi bi-eraser"></i> Clear All
          </b-button>
          <b-button size="sm" variant="outline-info" @click="expandAllSections()">
            <i class="bi bi-arrows-expand"></i> {{ allSectionsExpanded ? 'Collapse All' : 'Expand All' }}
          </b-button>
        </div>

        <!-- Past Medical History -->
        <div class="msk-section-card">
          <div class="msk-section-header" @click="toggleMskSection('history')">
            <div class="section-title-wrapper">
              <i class="bi bi-journal-medical"></i>
              <h4>Past Medical History</h4>
            </div>
            <i :class="mskExpandedSections.history ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </div>
          <div class="msk-section-body" v-show="mskExpandedSections.history">
            <textarea id="past_medical_history" v-model="newMSKReport.past_medical_history"
              placeholder="Enter any relevant medical history, previous injuries, surgeries, etc."></textarea>
          </div>
        </div>

        <!-- Hip Section -->
        <div class="msk-section-card">
          <div class="msk-section-header" @click="toggleMskSection('hip')">
            <div class="section-title-wrapper">
              <i class="bi bi-circle"></i>
              <h4>Hip Assessment</h4>
              <span class="section-completion" :class="getHipCompletionClass()">
                {{ getHipCompletionCount() }}/24 fields
              </span>
            </div>
            <i :class="mskExpandedSections.hip ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </div>
          <div class="msk-section-body" v-show="mskExpandedSections.hip">
            <!-- ROM Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                <b-button size="sm" variant="link" @click="fillHipNormalROM()">Fill Normal</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left (°)</th>
                    <th>Right (°)</th>
                    <th>Normal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Flexion</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_flexion" placeholder="0-120" /></td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_flexion" placeholder="0-120" /></td>
                    <td class="normal-range">0-120°</td>
                  </tr>
                  <tr>
                    <td>Extension</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_extension" placeholder="0-30" /></td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_extension" placeholder="0-30" /></td>
                    <td class="normal-range">0-30°</td>
                  </tr>
                  <tr>
                    <td>Abduction</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_abduction" placeholder="0-45" /></td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_abduction" placeholder="0-45" /></td>
                    <td class="normal-range">0-45°</td>
                  </tr>
                  <tr>
                    <td>Adduction</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_adduction" placeholder="0-30" /></td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_adduction" placeholder="0-30" /></td>
                    <td class="normal-range">0-30°</td>
                  </tr>
                  <tr>
                    <td>Internal Rotation</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_internal_rotation" placeholder="0-45" />
                    </td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_internal_rotation"
                        placeholder="0-45" />
                    </td>
                    <td class="normal-range">0-45°</td>
                  </tr>
                  <tr>
                    <td>External Rotation</td>
                    <td><input type="number" v-model="newMSKReport.hip_left_rom_external_rotation" placeholder="0-45" />
                    </td>
                    <td><input type="number" v-model="newMSKReport.hip_right_rom_external_rotation"
                        placeholder="0-45" />
                    </td>
                    <td class="normal-range">0-45°</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- MMT Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-speedometer2"></i> Manual Muscle Testing (MMT)</h5>
                <b-button size="sm" variant="link" @click="fillHipNormalMMT()">Fill 5/5</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left</th>
                    <th>Right</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Flexion</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_flexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_flexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Extension</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_extension" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_extension" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Abduction</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_abduction" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_abduction" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Adduction</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_adduction" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_adduction" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Internal Rotation</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_internal_rotation" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_internal_rotation" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>External Rotation</td>
                    <td>
                      <select v-model="newMSKReport.hip_left_mmt_external_rotation" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.hip_right_mmt_external_rotation" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Special Tests Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-clipboard-check"></i> Special Tests</h5>
                <b-button size="sm" variant="link" @click="fillHipNegativeTests()">All Negative</b-button>
              </div>
              <div class="special-tests-grid">
                <div class="special-test-row" v-for="test in hipSpecialTests" :key="test.key">
                  <span class="test-name">{{ test.name }}</span>
                  <div class="test-buttons">
                    <span class="side-label">L:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Positive'">+</button>
                    </div>
                    <span class="side-label">R:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Positive'">+</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Knee Section -->
        <div class="msk-section-card">
          <div class="msk-section-header" @click="toggleMskSection('knee')">
            <div class="section-title-wrapper">
              <i class="bi bi-circle"></i>
              <h4>Knee Assessment</h4>
              <span class="section-completion" :class="getKneeCompletionClass()">
                {{ getKneeCompletionCount() }}/20 fields
              </span>
            </div>
            <i :class="mskExpandedSections.knee ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </div>
          <div class="msk-section-body" v-show="mskExpandedSections.knee">
            <!-- ROM Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                <b-button size="sm" variant="link" @click="fillKneeNormalROM()">Fill Normal</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left (°)</th>
                    <th>Right (°)</th>
                    <th>Normal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Flexion</td>
                    <td><input type="number" v-model="newMSKReport.knee_left_rom_flexion" placeholder="0-140" /></td>
                    <td><input type="number" v-model="newMSKReport.knee_right_rom_flexion" placeholder="0-140" /></td>
                    <td class="normal-range">0-140°</td>
                  </tr>
                  <tr>
                    <td>Extension</td>
                    <td><input type="number" v-model="newMSKReport.knee_left_rom_extension" placeholder="0" /></td>
                    <td><input type="number" v-model="newMSKReport.knee_right_rom_extension" placeholder="0" /></td>
                    <td class="normal-range">0°</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- MMT Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-speedometer2"></i> Manual Muscle Testing (MMT)</h5>
                <b-button size="sm" variant="link" @click="fillKneeNormalMMT()">Fill 5/5</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left</th>
                    <th>Right</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Flexion</td>
                    <td>
                      <select v-model="newMSKReport.knee_left_mmt_flexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.knee_right_mmt_flexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Extension</td>
                    <td>
                      <select v-model="newMSKReport.knee_left_mmt_extension" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.knee_right_mmt_extension" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Special Tests Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-clipboard-check"></i> Special Tests</h5>
                <b-button size="sm" variant="link" @click="fillKneeNegativeTests()">All Negative</b-button>
              </div>
              <div class="special-tests-grid">
                <div class="special-test-row" v-for="test in kneeSpecialTests" :key="test.key">
                  <span class="test-name">{{ test.name }}</span>
                  <div class="test-buttons">
                    <span class="side-label">L:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Positive'">+</button>
                    </div>
                    <span class="side-label">R:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Positive'">+</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Ankle Section -->
        <div class="msk-section-card">
          <div class="msk-section-header" @click="toggleMskSection('ankle')">
            <div class="section-title-wrapper">
              <i class="bi bi-circle"></i>
              <h4>Ankle Assessment</h4>
              <span class="section-completion" :class="getAnkleCompletionClass()">
                {{ getAnkleCompletionCount() }}/26 fields
              </span>
            </div>
            <i :class="mskExpandedSections.ankle ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </div>
          <div class="msk-section-body" v-show="mskExpandedSections.ankle">
            <!-- ROM Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-arrows-angle-expand"></i> Range of Motion (ROM)</h5>
                <b-button size="sm" variant="link" @click="fillAnkleNormalROM()">Fill Normal</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left (°)</th>
                    <th>Right (°)</th>
                    <th>Normal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Dorsiflexion</td>
                    <td><input type="number" v-model="newMSKReport.ankle_left_rom_dorsiflexion" placeholder="0-20" />
                    </td>
                    <td><input type="number" v-model="newMSKReport.ankle_right_rom_dorsiflexion" placeholder="0-20" />
                    </td>
                    <td class="normal-range">0-20°</td>
                  </tr>
                  <tr>
                    <td>Plantarflexion</td>
                    <td><input type="number" v-model="newMSKReport.ankle_left_rom_plantarflexion" placeholder="0-50" />
                    </td>
                    <td><input type="number" v-model="newMSKReport.ankle_right_rom_plantarflexion" placeholder="0-50" />
                    </td>
                    <td class="normal-range">0-50°</td>
                  </tr>
                  <tr>
                    <td>Inversion</td>
                    <td><input type="number" v-model="newMSKReport.ankle_left_rom_inversion" placeholder="0-35" /></td>
                    <td><input type="number" v-model="newMSKReport.ankle_right_rom_inversion" placeholder="0-35" /></td>
                    <td class="normal-range">0-35°</td>
                  </tr>
                  <tr>
                    <td>Eversion</td>
                    <td><input type="number" v-model="newMSKReport.ankle_left_rom_eversion" placeholder="0-20" /></td>
                    <td><input type="number" v-model="newMSKReport.ankle_right_rom_eversion" placeholder="0-20" /></td>
                    <td class="normal-range">0-20°</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- MMT Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-speedometer2"></i> Manual Muscle Testing (MMT)</h5>
                <b-button size="sm" variant="link" @click="fillAnkleNormalMMT()">Fill 5/5</b-button>
              </div>
              <table class="msk-input-table">
                <thead>
                  <tr>
                    <th>Movement</th>
                    <th>Left</th>
                    <th>Right</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Dorsiflexion</td>
                    <td>
                      <select v-model="newMSKReport.ankle_left_mmt_dorsiflexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.ankle_right_mmt_dorsiflexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Plantarflexion</td>
                    <td>
                      <select v-model="newMSKReport.ankle_left_mmt_plantarflexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.ankle_right_mmt_plantarflexion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Inversion</td>
                    <td>
                      <select v-model="newMSKReport.ankle_left_mmt_inversion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.ankle_right_mmt_inversion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Eversion</td>
                    <td>
                      <select v-model="newMSKReport.ankle_left_mmt_eversion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="newMSKReport.ankle_right_mmt_eversion" class="mmt-select">
                        <option value="">-</option>
                        <option v-for="g in mmtGrades" :key="g" :value="g">{{ g }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Special Tests Subsection -->
            <div class="msk-subsection">
              <div class="subsection-header">
                <h5><i class="bi bi-clipboard-check"></i> Special Tests</h5>
                <b-button size="sm" variant="link" @click="fillAnkleNegativeTests()">All Negative</b-button>
              </div>
              <div class="special-tests-grid">
                <div class="special-test-row" v-for="test in ankleSpecialTests" :key="test.key">
                  <span class="test-name">{{ test.name }}</span>
                  <div class="test-buttons">
                    <span class="side-label">L:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.leftKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.leftKey] = 'Positive'">+</button>
                    </div>
                    <span class="side-label">R:</span>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Negative' ? 'btn-success' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Negative'">-</button>
                      <button type="button" class="btn"
                        :class="newMSKReport[test.rightKey] === 'Positive' ? 'btn-danger' : 'btn-outline-secondary'"
                        @click="newMSKReport[test.rightKey] = 'Positive'">+</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="msk-submit-section">
          <b-button type="submit" size="lg" variant="success" :disabled="$store.getters.isReadOnlySeason" v-if="newMSKReport.id === undefined">
            <i class="bi bi-check-circle"></i> Submit MSK Report
          </b-button>
          <b-button type="submit" size="lg" variant="success" :disabled="$store.getters.isReadOnlySeason" v-else>
            <i class="bi bi-check-circle"></i> Update MSK Report
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal v-if="showMskReportPDFModal" v-model="showMskReportPDFModal" size="xl" :hide-footer="true">
      <div class="performance-target-modal-content">
        <div class="modal-container performance-report">
          <iframe v-if="showReport === true" id="theMSKReport_preview" src="" />
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showPlayerIllnessReportPDFModal" v-model="showPlayerIllnessReportPDFModal" size="xl"
      :hide-footer="true">
      <div class="performance-target-modal-content">
        <div class="modal-container performance-report">
          <iframe v-if="showReport === true" id="playerIllnessReport_preview" src="" />
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showPlayerIllnessModal" v-model="showPlayerIllnessModal" size="xl" :hide-footer="true">
      <div class="performance-target-modal-content">
        <!-- Illness Tracking Form -->
        <div v-if="selectedTab === 'illness-tab'" class="illness-form-wrapper">
          <form class="form" @submit.prevent="saveIllnessReport">
            <h3>Record Player Illness</h3>

            <div class="form__item">
              <label class="form__label" for="illness_type">Illness Type</label>
              <select id="illness_type" v-model="newIllness.illness_type" required>
                <option value="">Select illness type</option>
                <option value="Virus">Virus</option>
                <option value="Cold">Cold</option>
                <option value="Infection">Infection</option>
                <option value="Mental Health Issue">Mental Health Issue</option>
                <option value="Sleep Disorder">Sleep Disorder</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div class="form__item" v-if="newIllness.illness_type === 'Other'">
              <label class="form__label" for="other_illness">Other Illness</label>
              <input id="other_illness" type="text" v-model="newIllness.other_illness" placeholder="Describe illness" />
            </div>

            <div class="form__item">
              <label class="form__label" for="illness_start">Start Date</label>
              <input id="illness_start" type="date" v-model="newIllness.start_date" required />
            </div>

            <div class="form__item">
              <label class="form__label" for="illness_end">End Date</label>
              <input id="illness_end" type="date" v-model="newIllness.end_date" />
            </div>

            <div class="form__item">
              <label class="form__label" for="illness_notes">Notes / Symptoms</label>
              <textarea id="illness_notes" class="form__input" v-model="newIllness.notes" rows="4"
                placeholder="Describe symptoms, treatment, etc."></textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="illness_status">Status</label>
              <select id="illness_status" v-model="newIllness.status" required>
                <option value="Active">Active</option>
                <option value="Recovered">Recovered</option>
                <option value="Ongoing">Ongoing</option>
              </select>
            </div>

            <b-button type="submit" size="lg" variant="outline-success" :disabled="$store.getters.isReadOnlySeason" v-if="newIllness.id === undefined">
              <i class="bi bi-file-text" aria-hidden="true"></i>
              Submit Illness Report
            </b-button>

            <b-button type="submit" size="lg" variant="outline-success" :disabled="$store.getters.isReadOnlySeason" v-else>
              <i class="bi bi-file-text" aria-hidden="true"></i>
              Edit Illness Report
            </b-button>
          </form>
        </div>
      </div>
    </b-modal>

    <!-- Start RTP Protocol Modal -->
    <b-modal v-if="showStartRTPModal" v-model="showStartRTPModal" size="md" title="Start Return to Play Protocol"
      :hide-footer="true">
      <div class="rtp-start-form">
        <div class="injury-context-banner" v-if="pendingRTPInjury">
          <div class="context-icon">
            <i class="bi bi-activity"></i>
          </div>
          <div class="context-info">
            <span class="injury-type">{{ pendingRTPInjury.injury_type }}</span>
            <span class="injury-date">Reported: {{ formatDateForHuman(pendingRTPInjury.created_date) }}</span>
          </div>
        </div>

        <div class="rtp-phase-info" style="background: #f8d7da; border-radius: 8px; padding: 1rem; margin: 1rem 0;">
          <h5 style="color: #dc3545; margin-bottom: 0.5rem;">
            <i class="bi bi-shield-check"></i> Phase 1: Acute/Rest
          </h5>
          <p style="margin: 0; font-size: 0.9rem; color: #666;">
            Rest and initial recovery. Focus on reducing inflammation and pain.
          </p>
        </div>

        <form class="form" @submit.prevent="startRTPProtocol()">
          <div class="form__item">
            <label class="form__label" for="rtp-target-date">Target Return Date (optional)</label>
            <input type="date" class="form-control" id="rtp-target-date" v-model="rtpForm.targetDate" />
          </div>

          <div class="form__item">
            <label class="form__label" for="rtp-restrictions">Restrictions / Notes (optional)</label>
            <textarea class="form-control" rows="3" id="rtp-restrictions" v-model="rtpForm.restrictions"
              placeholder="Any restrictions or notes for this player..."></textarea>
          </div>

          <div class="form-actions" style="display: flex; gap: 0.5rem; justify-content: flex-end; margin-top: 1rem;">
            <b-button variant="outline-secondary" @click="showStartRTPModal = false">
              Cancel
            </b-button>
            <b-button type="submit" variant="success" :disabled="startingRTP || $store.getters.isReadOnlySeason">
              <i class="bi bi-activity" aria-hidden="true"></i>
              {{ startingRTP ? 'Starting...' : 'Start RTP Protocol' }}
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- Confirmation Dialog Modal -->
    <div v-if="confirmDialog.show" class="modal-overlay" @click="handleConfirmCancel">
      <div class="modal-dialog modal-dialog-centered" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ confirmDialog.title }}</h5>
            <button type="button" class="btn-close" @click="handleConfirmCancel" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ confirmDialog.message }}</p>
          </div>
          <div class="modal-footer p-2">
            <button type="button" class="btn btn-secondary" @click="handleConfirmCancel">
              {{ confirmDialog.cancelTitle }}
            </button>
            <button type="button" class="btn btn-danger" @click="handleConfirmOk">
              {{ confirmDialog.okTitle }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { PlayerInjury } from "@/services/player-Injury-service.js";
import { Documents } from "@/services/documents-service.js";
import { ReturnToPlayService } from "@/services/rtp-service.js";
import { PhysioCalendarService } from "@/services/physio-calendar-service.js";
import DocumentUploader from "../../components/doucmentUploader";
import RTPPhaseTracker from "@/components/RTPPhaseTracker";
import PlayerRTPView from "@/components/PlayerRTPView";
import injuryBodyChart from "../injuryBodyChart";
import ConcussionAssessment from "./ConcussionAssessment.vue";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import JsPDF from "jspdf";
import { applyPlugin } from "jspdf-autotable";

applyPlugin(JsPDF);

export default {
  name: "PlayerInjuryReport",
  mixins: [extendSeasonEndDateToFullYearMixin],
  components: {
    injuryBodyChart,
    DocumentUploader,
    RTPPhaseTracker,
    PlayerRTPView,
    ConcussionAssessment,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    currentPlayingSeason: {
      type: String,
      required: true,
    },
    selectedUserValue: {
      type: Number,
      required: true,
    },
    selectedUserData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      confirmDialog: {
        show: false,
        message: "",
        title: "Confirm",
        okTitle: "OK",
        cancelTitle: "Cancel",
        resolve: null,
      },
      isRecording: null, // Tracks which field is being recorded (e.g., 'diagnosis', 'treatment')
      recognition: null, // Sp
      selectedTab: "injury-tab",
      allPlayerInjuryReports: [],
      selectedInjuryReports: [],
      selectedInjury: {},
      playerInjuryReportsData: [],
      playerInjuryData: [],
      playerLiveInjurydata: [],
      playerHistoricInjuryData: [],
      editInjuryReport: {},
      mskReportData: [],
      selectedMSKReport: {},
      newMSKReport: {
        player_id: "",
        team: "",
        past_medical_history: "",
        previous_injuries: "",

        // Hip ROM & MMT
        hip_left_rom_flexion: null,
        hip_right_rom_flexion: null,
        hip_left_rom_extension: null,
        hip_right_rom_extension: null,
        hip_left_rom_abduction: null,
        hip_right_rom_abduction: null,
        hip_left_rom_adduction: null,
        hip_right_rom_adduction: null,
        hip_left_rom_internal_rotation: null,
        hip_right_rom_internal_rotation: null,
        hip_left_rom_external_rotation: null,
        hip_right_rom_external_rotation: null,
        hip_left_mmt_flexion: "",
        hip_right_mmt_flexion: "",
        hip_left_mmt_extension: "",
        hip_right_mmt_extension: "",
        hip_left_mmt_abduction: "",
        hip_right_mmt_abduction: "",
        hip_left_mmt_adduction: "",
        hip_right_mmt_adduction: "",
        hip_left_mmt_internal_rotation: "",
        hip_right_mmt_internal_rotation: "",
        hip_left_mmt_external_rotation: "",
        hip_right_mmt_external_rotation: "",

        // Hip Special Tests
        hip_left_fabers_test: "",
        hip_right_fabers_test: "",
        hip_left_obers_test: "",
        hip_right_obers_test: "",
        hip_left_ely_test: "",
        hip_right_ely_test: "",
        hip_left_piriformis_test: "",
        hip_right_piriformis_test: "",

        // Knee ROM & MMT
        knee_left_rom_flexion: null,
        knee_right_rom_flexion: null,
        knee_left_rom_extension: null,
        knee_right_rom_extension: null,
        knee_left_mmt_flexion: "",
        knee_right_mmt_flexion: "",
        knee_left_mmt_extension: "",
        knee_right_mmt_extension: "",

        // Knee Special Tests
        knee_left_mcl: "",
        knee_right_mcl: "",
        knee_left_lcl: "",
        knee_right_lcl: "",
        knee_left_acl: "",
        knee_right_acl: "",
        knee_left_pcl: "",
        knee_right_pcl: "",
        knee_left_meniscus: "",
        knee_right_meniscus: "",
        knee_left_patellar_alignment: "",
        knee_right_patellar_alignment: "",

        // Ankle ROM & MMT
        ankle_left_rom_dorsiflexion: null,
        ankle_right_rom_dorsiflexion: null,
        ankle_left_rom_plantarflexion: null,
        ankle_right_rom_plantarflexion: null,
        ankle_left_rom_inversion: null,
        ankle_right_rom_inversion: null,
        ankle_left_rom_eversion: null,
        ankle_right_rom_eversion: null,
        ankle_left_mmt_dorsiflexion: "",
        ankle_right_mmt_dorsiflexion: "",
        ankle_left_mmt_plantarflexion: "",
        ankle_right_mmt_plantarflexion: "",
        ankle_left_mmt_inversion: "",
        ankle_right_mmt_inversion: "",
        ankle_left_mmt_eversion: "",
        ankle_right_mmt_eversion: "",

        // Ankle Special Tests
        ankle_left_subtalar_tilt: "",
        ankle_right_subtalar_tilt: "",
        ankle_left_anterior_drawer: "",
        ankle_right_anterior_drawer: "",
        ankle_left_posterior_drawer: "",
        ankle_right_posterior_drawer: "",
        ankle_left_mid_tarsal_joint: "",
        ankle_right_mid_tarsal_joint: "",
        ankle_left_knee_to_wall: "",
        ankle_right_knee_to_wall: "",
      },
      newInjuryInformation: {
        injury_type: "",
        more_detail: "",
        diagnosis: "",
        treatment: "",
        return_time: "",
        injury_status: "",
        playing_status: 1,
        training_status: "Fully",
        activity_at_time: "",
        reasion_for_presentation: "",
        contact: "",
      },
      playerInjuryHistoryAmounts: {
        headNeckInjury: 0,
        shoulderInjury: 0,
        armInjury: 0,
        wristAndHandInjury: 0,
        hipInjury: 0,
        groinInjury: 0,
        quadInjury: 0,
        hamstringInjury: 0,
        kneeInjury: 0,
        calfInjury: 0,
        ankleInjury: 0,
        footInjury: 0,
      },
      reportDocuments: [],
      uploadedDocuments: [],
      showReport: false,
      illnessReportData: [],
      newIllness: {
        illness_type: "",
        other_illness: "",
        start_date: "",
        end_date: "",
        notes: "",
        status: "Active",
      },
      mskReportDocuments: [],
      allPhysios: [],
      clubLogoLoaded: null, // For PDF logo embedding
      // Modal visibility properties for Vue 3 pattern
      showPlayerInjuryModal: false,
      showEditPlayerInjuryModal: false,
      showAllplayerInjuryReportsModal: false,
      showMskReportModal: false,
      showMskReportPDFModal: false,
      showPlayerIllnessReportPDFModal: false,
      showPlayerIllnessModal: false,
      showAddTreatmentModal: false,
      newTreatmentRecord: {
        treatment: '',
        physio_id: ''
      },

      // Season management
      selectedSeason: "current", // 'current' | 'last'

      // Last season data stores
      lastSeasonPlayerInjuryData: [],
      lastSeasonMskReportData: [],
      lastSeasonIllnessReportData: [],
      lastSeasonPlayerInjuryReportsData: [],
      lastSeasonAllPlayerInjuryReports: [],

      // Physio appointments for selected player
      playerPhysioAppointments: [],
      physioAppointmentsLoading: false,

      loadingLastSeason: false,
      comparisonMode: false,

      // RTP Protocol properties
      showStartRTPModal: false,
      pendingRTPInjury: null,
      startingRTP: false,
      rtpForm: {
        targetDate: '',
        restrictions: ''
      },

      // MSK Form Improvements
      mskExpandedSections: {
        history: true,
        hip: true,
        knee: false,
        ankle: false
      },
      allSectionsExpanded: false,
      mmtGrades: ['0/5', '1/5', '2/5', '3/5', '4/5', '5/5', '4+/5', '4-/5', '3+/5', '3-/5'],
      hipSpecialTests: [
        { name: "FABER's Test", key: 'fabers', leftKey: 'hip_left_fabers_test', rightKey: 'hip_right_fabers_test' },
        { name: "Ober's Test", key: 'obers', leftKey: 'hip_left_obers_test', rightKey: 'hip_right_obers_test' },
        { name: "Ely's Test", key: 'ely', leftKey: 'hip_left_ely_test', rightKey: 'hip_right_ely_test' },
        { name: "Piriformis Test", key: 'piriformis', leftKey: 'hip_left_piriformis_test', rightKey: 'hip_right_piriformis_test' }
      ],
      kneeSpecialTests: [
        { name: "MCL", key: 'mcl', leftKey: 'knee_left_mcl', rightKey: 'knee_right_mcl' },
        { name: "LCL", key: 'lcl', leftKey: 'knee_left_lcl', rightKey: 'knee_right_lcl' },
        { name: "ACL", key: 'acl', leftKey: 'knee_left_acl', rightKey: 'knee_right_acl' },
        { name: "PCL", key: 'pcl', leftKey: 'knee_left_pcl', rightKey: 'knee_right_pcl' },
        { name: "Meniscus", key: 'meniscus', leftKey: 'knee_left_meniscus', rightKey: 'knee_right_meniscus' },
        { name: "Patellar Alignment", key: 'patellar', leftKey: 'knee_left_patellar_alignment', rightKey: 'knee_right_patellar_alignment' }
      ],
      ankleSpecialTests: [
        { name: "Subtalar Tilt", key: 'subtalar', leftKey: 'ankle_left_subtalar_tilt', rightKey: 'ankle_right_subtalar_tilt' },
        { name: "Anterior Drawer", key: 'ant_drawer', leftKey: 'ankle_left_anterior_drawer', rightKey: 'ankle_right_anterior_drawer' },
        { name: "Posterior Drawer", key: 'post_drawer', leftKey: 'ankle_left_posterior_drawer', rightKey: 'ankle_right_posterior_drawer' },
        { name: "Mid Tarsal Joint", key: 'mid_tarsal', leftKey: 'ankle_left_mid_tarsal_joint', rightKey: 'ankle_right_mid_tarsal_joint' },
        { name: "Knee to Wall", key: 'knee_wall', leftKey: 'ankle_left_knee_to_wall', rightKey: 'ankle_right_knee_to_wall' }
      ],
    };
  },
  computed: {
    isAdminOrCoach() {
      return (
        this.userData.userType === "Admin" || this.userData.userType === "Coach"
      );
    },

    // Check if the logged-in user is viewing their own injury data
    // Only true when the logged-in user IS the player whose injury is being viewed
    isViewingOwnInjury() {
      return String(this.userData.id) === String(this.selectedUserData.id);
    },

    // Season utility computed properties
    selectedSeasonLabel() {
      return this.selectedSeason === "current"
        ? this.getCurrentSeason().label
        : this.getLastSeason().label;
    },

    currentSeasonDates() {
      return this.selectedSeason === "current"
        ? this.getCurrentSeason()
        : this.getLastSeason();
    },

    // Dynamic data getters based on selected season
    activePlayerInjuryData() {
      return this.selectedSeason === "current"
        ? this.playerInjuryData
        : this.lastSeasonPlayerInjuryData;
    },

    activePlayerLiveInjuryData() {
      return this.selectedSeason === "current"
        ? this.playerLiveInjurydata
        : this.lastSeasonPlayerLiveInjuryData;
    },

    activePlayerHistoricInjuryData() {
      return this.selectedSeason === "current"
        ? this.playerHistoricInjuryData
        : this.lastSeasonPlayerHistoricInjuryData;
    },

    activeMskReportData() {
      return this.selectedSeason === "current"
        ? this.mskReportData
        : this.lastSeasonMskReportData;
    },

    activeIllnessReportData() {
      return this.selectedSeason === "current"
        ? this.illnessReportData
        : this.lastSeasonIllnessReportData;
    },

    // Comparison mode computed properties
    lastSeasonPlayerLiveInjuryData() {
      return this.lastSeasonPlayerInjuryData.filter(
        (injury) => injury.injury_status !== "Recovered",
      );
    },

    lastSeasonPlayerHistoricInjuryData() {
      return this.lastSeasonPlayerInjuryData.filter(
        (injury) => injury.injury_status === "Recovered",
      );
    },

    // Trend analysis computed properties
    injuryTrendPercentage() {
      const current = this.activePlayerInjuryData.length;
      const last = this.lastSeasonPlayerInjuryData.length;
      if (last === 0) return current > 0 ? "+100%" : "0%";
      const change = ((current - last) / last) * 100;
      return change > 0 ? `+${change.toFixed(1)}%` : `${change.toFixed(1)}%`;
    },

    injuryTrendClass() {
      const current = this.activePlayerInjuryData.length;
      const last = this.lastSeasonPlayerInjuryData.length;
      return current > last
        ? "trend-worse"
        : current < last
          ? "trend-better"
          : "trend-same";
    },

    injuryTrendIcon() {
      const current = this.activePlayerInjuryData.length;
      const last = this.lastSeasonPlayerInjuryData.length;
      return current > last
        ? "bi-arrow-up"
        : current < last
          ? "bi-arrow-down"
          : "bi-arrow-right";
    },

    liveInjuryTrendPercentage() {
      const current = this.activePlayerLiveInjuryData.length;
      const last = this.lastSeasonPlayerLiveInjuryData.length;
      if (last === 0) return current > 0 ? "+100%" : "0%";
      const change = ((current - last) / last) * 100;
      return change > 0 ? `+${change.toFixed(1)}%` : `${change.toFixed(1)}%`;
    },

    liveInjuryTrendClass() {
      const current = this.activePlayerLiveInjuryData.length;
      const last = this.lastSeasonPlayerLiveInjuryData.length;
      return current > last
        ? "trend-worse"
        : current < last
          ? "trend-better"
          : "trend-same";
    },

    liveInjuryTrendIcon() {
      const current = this.activePlayerLiveInjuryData.length;
      const last = this.lastSeasonPlayerLiveInjuryData.length;
      return current > last
        ? "bi-arrow-up"
        : current < last
          ? "bi-arrow-down"
          : "bi-arrow-right";
    },

    currentSeasonRecoveryRate() {
      const total = this.activePlayerInjuryData.length;
      if (total === 0) return 0;
      const recovered = this.activePlayerHistoricInjuryData.length;
      return Math.round((recovered / total) * 100);
    },

    lastSeasonRecoveryRate() {
      const total = this.lastSeasonPlayerInjuryData.length;
      if (total === 0) return 0;
      const recovered = this.lastSeasonPlayerHistoricInjuryData.length;
      return Math.round((recovered / total) * 100);
    },

    recoveryTrendPercentage() {
      const current = this.currentSeasonRecoveryRate;
      const last = this.lastSeasonRecoveryRate;
      if (last === 0) return current > 0 ? "+100%" : "0%";
      const change = current - last;
      return change > 0 ? `+${change}%` : `${change}%`;
    },

    recoveryTrendClass() {
      const current = this.currentSeasonRecoveryRate;
      const last = this.lastSeasonRecoveryRate;
      return current > last
        ? "trend-better"
        : current < last
          ? "trend-worse"
          : "trend-same";
    },

    recoveryTrendIcon() {
      const current = this.currentSeasonRecoveryRate;
      const last = this.lastSeasonRecoveryRate;
      return current > last
        ? "bi-arrow-up"
        : current < last
          ? "bi-arrow-down"
          : "bi-arrow-right";
    },

    // MSK Report completion percentage
    mskCompletionPercent() {
      const fields = [
        'hip_left_rom_flexion', 'hip_right_rom_flexion', 'hip_left_rom_extension', 'hip_right_rom_extension',
        'hip_left_rom_abduction', 'hip_right_rom_abduction', 'hip_left_rom_adduction', 'hip_right_rom_adduction',
        'hip_left_rom_internal_rotation', 'hip_right_rom_internal_rotation', 'hip_left_rom_external_rotation', 'hip_right_rom_external_rotation',
        'hip_left_mmt_flexion', 'hip_right_mmt_flexion', 'hip_left_mmt_extension', 'hip_right_mmt_extension',
        'hip_left_mmt_abduction', 'hip_right_mmt_abduction', 'hip_left_mmt_adduction', 'hip_right_mmt_adduction',
        'hip_left_mmt_internal_rotation', 'hip_right_mmt_internal_rotation', 'hip_left_mmt_external_rotation', 'hip_right_mmt_external_rotation',
        'knee_left_rom_flexion', 'knee_right_rom_flexion', 'knee_left_rom_extension', 'knee_right_rom_extension',
        'knee_left_mmt_flexion', 'knee_right_mmt_flexion', 'knee_left_mmt_extension', 'knee_right_mmt_extension',
        'ankle_left_rom_dorsiflexion', 'ankle_right_rom_dorsiflexion', 'ankle_left_rom_plantarflexion', 'ankle_right_rom_plantarflexion',
        'ankle_left_rom_inversion', 'ankle_right_rom_inversion', 'ankle_left_rom_eversion', 'ankle_right_rom_eversion',
        'ankle_left_mmt_dorsiflexion', 'ankle_right_mmt_dorsiflexion', 'ankle_left_mmt_plantarflexion', 'ankle_right_mmt_plantarflexion',
        'ankle_left_mmt_inversion', 'ankle_right_mmt_inversion', 'ankle_left_mmt_eversion', 'ankle_right_mmt_eversion'
      ];
      const filled = fields.filter(f => this.newMSKReport[f] !== null && this.newMSKReport[f] !== '').length;
      return Math.round((filled / fields.length) * 100);
    },

    // MSK Dashboard computed properties
    latestMskReport() {
      if (!this.activeMskReportData || this.activeMskReportData.length === 0) return null;
      return this.activeMskReportData[0]; // Most recent report
    },

    mskDashboardData() {
      const reports = this.activeMskReportData;
      if (!reports || reports.length === 0) return null;

      const latest = reports[0];
      const previous = reports.length > 1 ? reports[1] : null;

      // Normal ROM ranges for comparison
      const normalRanges = {
        hip: { flexion: 120, extension: 30, abduction: 45, adduction: 30, internal_rotation: 45, external_rotation: 45 },
        knee: { flexion: 140, extension: 0 },
        ankle: { dorsiflexion: 20, plantarflexion: 50, inversion: 35, eversion: 20 }
      };

      // Calculate averages and status for each joint
      const getJointData = (joint, movements) => {
        const data = {};
        movements.forEach(movement => {
          const leftKey = `${joint}_left_rom_${movement}`;
          const rightKey = `${joint}_right_rom_${movement}`;
          const leftVal = parseFloat(latest[leftKey]) || 0;
          const rightVal = parseFloat(latest[rightKey]) || 0;
          const normal = normalRanges[joint]?.[movement] || 0;

          const prevLeftVal = previous ? (parseFloat(previous[leftKey]) || 0) : null;
          const prevRightVal = previous ? (parseFloat(previous[rightKey]) || 0) : null;

          data[movement] = {
            left: leftVal,
            right: rightVal,
            normal: normal,
            leftStatus: this.getRomStatus(leftVal, normal, movement),
            rightStatus: this.getRomStatus(rightVal, normal, movement),
            leftTrend: prevLeftVal !== null ? leftVal - prevLeftVal : null,
            rightTrend: prevRightVal !== null ? rightVal - prevRightVal : null
          };
        });
        return data;
      };

      // Get MMT data
      const getMmtData = (joint, movements) => {
        const data = {};
        movements.forEach(movement => {
          const leftKey = `${joint}_left_mmt_${movement}`;
          const rightKey = `${joint}_right_mmt_${movement}`;
          data[movement] = {
            left: latest[leftKey] || '-',
            right: latest[rightKey] || '-',
            leftStatus: this.getMmtStatus(latest[leftKey]),
            rightStatus: this.getMmtStatus(latest[rightKey])
          };
        });
        return data;
      };

      // Get special test results
      const getSpecialTestData = (tests, report) => {
        return tests.map(test => ({
          name: test.name,
          left: report[test.leftKey] || '-',
          right: report[test.rightKey] || '-',
          leftStatus: this.getTestStatus(report[test.leftKey]),
          rightStatus: this.getTestStatus(report[test.rightKey])
        }));
      };

      return {
        assessmentDate: latest.assessment_date || latest.created_at,
        totalReports: reports.length,
        hip: {
          rom: getJointData('hip', ['flexion', 'extension', 'abduction', 'adduction', 'internal_rotation', 'external_rotation']),
          mmt: getMmtData('hip', ['flexion', 'extension', 'abduction', 'adduction', 'internal_rotation', 'external_rotation']),
          specialTests: getSpecialTestData(this.hipSpecialTests, latest)
        },
        knee: {
          rom: getJointData('knee', ['flexion', 'extension']),
          mmt: getMmtData('knee', ['flexion', 'extension']),
          specialTests: getSpecialTestData(this.kneeSpecialTests, latest)
        },
        ankle: {
          rom: getJointData('ankle', ['dorsiflexion', 'plantarflexion', 'inversion', 'eversion']),
          mmt: getMmtData('ankle', ['dorsiflexion', 'plantarflexion', 'inversion', 'eversion']),
          specialTests: getSpecialTestData(this.ankleSpecialTests, latest)
        },
        medicalHistory: latest.past_medical_history || 'None recorded',
        previousInjuries: latest.previous_injuries || 'None recorded'
      };
    },

    mskOverallScore() {
      if (!this.mskDashboardData) return 0;
      const data = this.mskDashboardData;
      let totalScore = 0;
      let totalFields = 0;

      // Count ROM scores (within 80% of normal = full score)
      ['hip', 'knee', 'ankle'].forEach(joint => {
        Object.values(data[joint].rom).forEach(movement => {
          if (movement.left > 0) {
            totalScore += movement.leftStatus === 'good' ? 1 : (movement.leftStatus === 'warning' ? 0.5 : 0);
            totalFields++;
          }
          if (movement.right > 0) {
            totalScore += movement.rightStatus === 'good' ? 1 : (movement.rightStatus === 'warning' ? 0.5 : 0);
            totalFields++;
          }
        });
      });

      return totalFields > 0 ? Math.round((totalScore / totalFields) * 100) : 0;
    },

    mskPositiveTestsCount() {
      if (!this.mskDashboardData) return { positive: 0, total: 0 };
      const data = this.mskDashboardData;
      let positive = 0;
      let total = 0;

      ['hip', 'knee', 'ankle'].forEach(joint => {
        data[joint].specialTests.forEach(test => {
          if (test.left && test.left !== '-') {
            total++;
            if (test.left === 'Positive') positive++;
          }
          if (test.right && test.right !== '-') {
            total++;
            if (test.right === 'Positive') positive++;
          }
        });
      });

      return { positive, total };
    },
  },
  mounted() {
    this.loadAllInjuryReportDependencies();
    this.loadClubLogo();
  },
  methods: {
    // Serve documents via the PHP endpoint (resolves the uploads/documents
    // folder + legacy root). Mirrors documents/index.vue.
    getDocumentUrl(filename) {
      if (!filename) return "";
      if (window.location.href.indexOf("8080") > -1) {
        return `http://www.localhost:8888/serve-document.php?file=${encodeURIComponent(filename)}`;
      }
      return `/personal-training-BE/serve-document.php?file=${encodeURIComponent(filename)}`;
    },
    // Load club logo for PDF embedding
    async loadClubLogo() {
      const headerLogo = document.getElementById('main-logo');
      if (!headerLogo) {
        console.warn('Header logo element #main-logo not found');
        return null;
      }

      return new Promise((resolve) => {
        const processLogo = () => {
          try {
            const width = 150;
            const height = 150;
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, height);

            const imgWidth = headerLogo.naturalWidth || headerLogo.width || width;
            const imgHeight = headerLogo.naturalHeight || headerLogo.height || height;
            const scale = Math.min(width / imgWidth, height / imgHeight);
            const scaledWidth = imgWidth * scale;
            const scaledHeight = imgHeight * scale;
            const offsetX = (width - scaledWidth) / 2;
            const offsetY = (height - scaledHeight) / 2;

            ctx.drawImage(headerLogo, offsetX, offsetY, scaledWidth, scaledHeight);
            this.clubLogoLoaded = canvas.toDataURL('image/png');
            resolve(this.clubLogoLoaded);
          } catch (e) {
            console.warn('Failed to convert header logo to canvas:', e);
            this.clubLogoLoaded = null;
            resolve(null);
          }
        };

        if (headerLogo.complete && headerLogo.naturalWidth > 0) {
          processLogo();
        } else {
          headerLogo.onload = processLogo;
          headerLogo.onerror = () => {
            this.clubLogoLoaded = null;
            resolve(null);
          };
        }
      });
    },

    // Season utility methods
    getCurrentSeason() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const isAfterAugust = now.getMonth() >= 7; // August is month 7 (0-indexed)

      return {
        startYear: isAfterAugust ? currentYear : currentYear - 1,
        endYear: isAfterAugust ? currentYear + 1 : currentYear,
        label: isAfterAugust
          ? `${currentYear}/${currentYear + 1}`
          : `${currentYear - 1}/${currentYear}`,
        startDate: `${isAfterAugust ? currentYear : currentYear - 1}-08-01`,
        endDate: `${isAfterAugust ? currentYear + 1 : currentYear}-05-30`,
      };
    },
    getLastSeason() {
      const current = this.getCurrentSeason();
      return {
        startYear: current.startYear - 1,
        endYear: current.endYear - 1,
        label: `${current.startYear - 1}/${current.endYear - 1}`,
        startDate: `${current.startYear - 1}-08-01`,
        endDate: `${current.endYear - 1}-05-30`,
      };
    },
    async switchSeason(season) {
      this.selectedSeason = season;

      if (season === "last" && this.lastSeasonPlayerInjuryData.length === 0) {
        this.loadingLastSeason = true;
        await this.loadLastSeasonData();
        this.loadingLastSeason = false;
      }

      // Refresh current tab data
      this.refreshCurrentTabData();
    },

    async toggleComparisonMode() {
      this.comparisonMode = !this.comparisonMode;

      // If entering comparison mode, ensure last season data is loaded
      if (this.comparisonMode && this.lastSeasonPlayerInjuryData.length === 0) {
        this.loadingLastSeason = true;
        await this.loadLastSeasonData();
        this.loadingLastSeason = false;
      }
    },

    async loadLastSeasonData() {
      const lastSeason = this.getLastSeason();

      try {
        await Promise.all([
          this.getPlayerInjuryInformationForSeason(lastSeason, "last"),
          this.getPlayerInjuryReportForSeason(lastSeason, "last"),
          this.getAllPlayerInjuryReportsForSeason(lastSeason, "last"),
          this.getplayerJointAssessmentDataForSeason(lastSeason, "last"),
          this.getIllnessReportForSeason(lastSeason, "last"),
        ]);
      } catch (error) {
        console.error("Error loading last season data:", error);
        this.$toast.error("Failed to load last season data");
      }
    },

    refreshCurrentTabData() {
      // Refresh data for currently active tab based on selected season
      switch (this.selectedTab) {
        case "injury-tab":
          if (this.selectedSeason === "current") {
            this.getPlayerInjuryInformation();
          }
          break;
        case "reports-tab":
          if (this.selectedSeason === "current") {
            this.getplayerJointAssessmentData();
          }
          break;
        case "illness-tab":
          if (this.selectedSeason === "current") {
            this.getIllnessReport();
          }
          break;
      }
    },

    // Season-specific data loading methods
    // Note: lastSeasonPlayerLiveInjuryData and lastSeasonPlayerHistoricInjuryData
    // are now computed properties that automatically filter from lastSeasonPlayerInjuryData
    async getPlayerInjuryInformationForSeason(
      seasonDates,
      seasonType = "current",
    ) {
      const userData = {
        player_id: this.selectedUserValue,
        year: seasonDates.label,
        action: "getPlayerInjuryInformation",
        season_start_date: seasonDates.startDate,
        season_end_date: seasonDates.endDate,
      };

      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.data && response.data.length > 0) {
        if (seasonType === "current") {
          this.playerInjuryData = response.data;
          this.setLiveInjuryData();
          this.setHistoricInjuryData();
        } else {
          // Computed properties automatically filter live/historic from lastSeasonPlayerInjuryData
          this.lastSeasonPlayerInjuryData = response.data;
        }
      }
    },

    async getPlayerInjuryReportForSeason(seasonDates, seasonType = "current") {
      const userData = {
        player_id: this.selectedUserValue,
        year: seasonDates.label,
        action: "getPlayerInjuryReport",
        season_start_date: seasonDates.startDate,
        season_end_date: seasonDates.endDate,
      };

      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.data && response.data.length > 0) {
        if (seasonType === "current") {
          this.playerInjuryReportsData = response.data;
        } else {
          this.lastSeasonPlayerInjuryReportsData = response.data;
        }
      }
    },

    async getAllPlayerInjuryReportsForSeason(
      seasonDates,
      seasonType = "current",
    ) {
      const userData = {
        player_id: this.selectedUserValue,
        year: seasonDates.label,
        action: "getAllPlayerInjuryReports",
        season_start_date: seasonDates.startDate,
        season_end_date: seasonDates.endDate,
      };

      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.data && response.data.length > 0) {
        if (seasonType === "current") {
          this.allPlayerInjuryReports = response.data;
        } else {
          this.lastSeasonAllPlayerInjuryReports = response.data;
        }
      }
    },

    async getplayerJointAssessmentDataForSeason(
      seasonDates,
      seasonType = "current",
    ) {
      const userData = {
        player_id: this.selectedUserValue,
        year: seasonDates.label,
        action: "getplayerJointAssessmentData",
        season_start_date: seasonDates.startDate,
        season_end_date: seasonDates.endDate,
      };

      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.data && response.data.length > 0) {
        if (seasonType === "current") {
          this.mskReportData = response.data;
        } else {
          this.lastSeasonMskReportData = response.data;
        }
      }
    },

    async getIllnessReportForSeason(seasonDates, seasonType = "current") {
      const userData = {
        player_id: this.selectedUserValue,
        year: seasonDates.label,
        action: "getIllnessReport",
        season_start_date: seasonDates.startDate,
        season_end_date: seasonDates.endDate,
      };

      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (response && response.data && response.data.length > 0) {
        if (seasonType === "current") {
          this.illnessReportData = response.data;
        } else {
          this.lastSeasonIllnessReportData = response.data;
        }
      }
    },

    showConfirmDialog(message, options = {}) {
      return new Promise((resolve) => {
        // Set up the confirmation modal data
        this.confirmDialog = {
          show: true,
          message: message,
          title: options.title || "Confirm",
          okTitle: options.okTitle || "OK",
          cancelTitle: options.cancelTitle || "Cancel",
          resolve: resolve,
        };
      });
    },
    handleConfirmOk() {
      this.confirmDialog.resolve(true);
      this.confirmDialog.show = false;
    },
    handleConfirmCancel() {
      this.confirmDialog.resolve(false);
      this.confirmDialog.show = false;
    },
    removeNumberFromStart(documentName) {
      return documentName.substring(documentName.indexOf("_") + 1);
    },
    async getAllPhysios() {
      const data = {
        action: "getAllPhysios",
        clubId: this.userData.clubId,
      };
      const response = await PlayerInjury.find(data);
      if (response.status === 200) {
        this.allPhysios = response.data;
      }
    },
    viewllnessReport(report) {
      this.showReport = true;
      this.selectedIllnessReport = report;
      this.showPlayerIllnessReportPDFModal = true;

      setTimeout(() => {
        let pdf = this.buildIllnessReportPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    buildIllnessReportPDF() {
      const pdf = new JsPDF("p", "mm", "a4");
      const report =
        this.selectedIllnessReport || this.illnessReportData[0] || {};
      let y = 20;

      // Title
      pdf.setFontSize(18);
      pdf.text("Player Illness Report", 15, y);
      y += 12;

      // Player & Date
      pdf.setFontSize(12);
      pdf.text(`Player: ${this.selectedUserData.name || ""}`, 15, y);
      y += 8;
      pdf.text(`Illness Start Date: ${report.start_date || ""}`, 15, y);
      y += 8;
      pdf.text(`Illness End Date: ${report.end_date || "Ongoing"}`, 15, y);
      y += 12;

      // Illness Details
      pdf.setFontSize(14);
      pdf.text("Illness Details", 15, y);
      y += 8;
      pdf.setFontSize(11);
      pdf.text(`Type: ${report.illness_type || ""}`, 20, y);
      y += 7;
      if (report.illness_type === "Other" && report.other_illness) {
        pdf.text(`Other Illness: ${report.other_illness}`, 20, y);
        y += 7;
      }
      pdf.text(`Status: ${report.status || ""}`, 20, y);
      y += 7;

      // Notes / Symptoms
      y += 5;
      pdf.setFontSize(14);
      pdf.text("Notes / Symptoms", 15, y);
      y += 8;
      pdf.setFontSize(11);

      // Split long notes into lines
      const notes = report.notes || "";
      const notesLines = pdf.splitTextToSize(notes, 170);
      pdf.text(notesLines, 20, y);
      y += notesLines.length * 7 + 5;

      // Footer
      pdf.setFontSize(10);
      pdf.text(`Generated: ${new Date().toLocaleDateString("en-GB")}`, 15, 285);

      let previewContainer = document.getElementById(
        "playerIllnessReport_preview",
      );
      return { pdfData: pdf, previewLink: previewContainer };
    },
    async editIllnessReport(report) {
      this.newIllness = { ...report }; // Clone the report data for editing
      this.showPlayerIllnessModal = true;
    },
    async deleteIllnessReport(reportId) {
      const confirmed = await this.showConfirmDialog(
        "Are you sure you want to delete this report?",
        {
          title: "Confirm Deletion",
          okTitle: "Yes",
          cancelTitle: "No",
        },
      );

      if (confirmed) {
        const response = await PlayerInjury.find({
          action: "deleteIllnessReport",
          id: reportId,
        });

        if (response.status === 200) {
          this.$toast.success("Illness report deleted", {
            title: "Success",
            solid: true,
          });
          this.getIllnessReport(); // Refresh the list
        } else {
          this.$toast.error("Failed to delete illness report", {
            title: "Error",
            solid: true,
          });
        }
      }
    },
    buildMSKReportPDF() {
      let previewContainer = document.getElementById("theMSKReport_preview");
      const pdf = new JsPDF("p", "mm", "a4");
      const report = this.selectedMSKReport || this.newMSKReport;
      const pageWidth = pdf.internal.pageSize.getWidth();
      let y = 20;

      // Add club logo in top right corner
      if (this.clubLogoLoaded) {
        try {
          pdf.addImage(this.clubLogoLoaded, "PNG", pageWidth - 40, 5, 25, 25);
        } catch (e) {
          console.warn('Failed to add club logo to PDF:', e);
        }
      }

      // Title & Player Info
      pdf.setFontSize(12);
      if (this.selectedUserData !== undefined) {
        pdf.text(`Name: ${this.selectedUserData.name || ""}`, 15, y);
      }
      y += 8;
      if (this.selectedUserData !== undefined) {
        pdf.text(`Team: ${this.selectedUserData.age_group || ""}`, 15, y);
      }
      y += 8;
      pdf.text(
        `Assessment Date: ${report.assessment_date ? this.formatDateForHuman(report.assessment_date) : "N/A"}`,
        15,
        y,
      );
      y += 8;
      pdf.text(
        `Past Medical History: ${report.past_medical_history || "None"}`,
        15,
        y,
      );
      y += 8;
      pdf.text(
        `Previous Injuries: ${report.previous_injuries || "None"}`,
        15,
        y,
      );
      y += 10;

      // Hip Joint Table
      pdf.setFont(undefined, "bold");
      pdf.text("Hip Joint:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 6;

      pdf.autoTable({
        startY: y,
        head: [
          [
            "ROM & MMT",
            "Left ROM",
            "Right ROM",
            "Normal range",
            "Left MMT",
            "Right MMT",
          ],
        ],
        body: [
          [
            "Flexion",
            report.hip_left_rom_flexion || "-",
            report.hip_right_rom_flexion || "-",
            "130",
            report.hip_left_mmt_flexion || "-",
            report.hip_right_mmt_flexion || "-",
          ],
          [
            "Extension",
            report.hip_left_rom_extension || "-",
            report.hip_right_rom_extension || "-",
            "10-20",
            report.hip_left_mmt_extension || "-",
            report.hip_right_mmt_extension || "-",
          ],
          [
            "Abduction",
            report.hip_left_rom_abduction || "-",
            report.hip_right_rom_abduction || "-",
            "50",
            report.hip_left_mmt_abduction || "-",
            report.hip_right_mmt_abduction || "-",
          ],
          [
            "Adduction",
            report.hip_left_rom_adduction || "-",
            report.hip_right_rom_adduction || "-",
            "50",
            report.hip_left_mmt_adduction || "-",
            report.hip_right_mmt_adduction || "-",
          ],
          [
            "Internal Rotation",
            report.hip_left_rom_internal_rotation || "-",
            report.hip_right_rom_internal_rotation || "-",
            "70",
            report.hip_left_mmt_internal_rotation || "-",
            report.hip_right_mmt_internal_rotation || "-",
          ],
          [
            "External Rotation",
            report.hip_left_rom_external_rotation || "-",
            report.hip_right_rom_external_rotation || "-",
            "45",
            report.hip_left_mmt_external_rotation || "-",
            report.hip_right_mmt_external_rotation || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      y = pdf.lastAutoTable.finalY + 7;

      // Hip Special Tests
      pdf.setFont(undefined, "bold");
      pdf.text("Special Test:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 2;

      pdf.autoTable({
        startY: y,
        head: [["", "Left", "Right"]],
        body: [
          [
            "Faber's Test",
            report.hip_left_fabers_test || "-",
            report.hip_right_fabers_test || "-",
          ],
          [
            "Ober's Test",
            report.hip_left_obers_test || "-",
            report.hip_right_obers_test || "-",
          ],
          ["Ely Test", report.hip_left_ely_test || "-", report.hip_right_ely_test || "-"],
          [
            "Piriformis Test",
            report.hip_left_piriformis_test || "-",
            report.hip_right_piriformis_test || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      y = pdf.lastAutoTable.finalY + 8;

      // Knee Joint Table
      pdf.setFont(undefined, "bold");
      pdf.text("Knee Joint:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 6;

      pdf.autoTable({
        startY: y,
        head: [
          [
            "ROM & MMT",
            "Left ROM",
            "Right ROM",
            "Normal Range",
            "Left MMT",
            "Right MMT",
          ],
        ],
        body: [
          [
            "Flexion",
            report.knee_left_rom_flexion || "-",
            report.knee_right_rom_flexion || "-",
            "140",
            report.knee_left_mmt_flexion || "-",
            report.knee_right_mmt_flexion || "-",
          ],
          [
            "Extension",
            report.knee_left_rom_extension || "-",
            report.knee_right_rom_extension || "-",
            "0",
            report.knee_left_mmt_extension || "-",
            report.knee_right_mmt_extension || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      y = pdf.lastAutoTable.finalY + 7;

      // Knee Special Tests
      pdf.setFont(undefined, "bold");
      pdf.text("Special Test:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 2;

      pdf.autoTable({
        startY: y,
        head: [["", "Left", "Right"]],
        body: [
          ["MCL", report.knee_left_mcl || "-", report.knee_right_mcl || "-"],
          ["LCL", report.knee_left_lcl || "-", report.knee_right_lcl || "-"],
          ["ACL", report.knee_left_acl || "-", report.knee_right_acl || "-"],
          ["PCL", report.knee_left_pcl || "-", report.knee_right_pcl || "-"],
          ["Meniscus", report.knee_left_meniscus || "-", report.knee_right_meniscus || "-"],
          [
            "Patellar alignment",
            report.knee_left_patellar_alignment || "-",
            report.knee_right_patellar_alignment || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      y = pdf.lastAutoTable.finalY + 8;

      // Ankle Joint Table
      pdf.setFont(undefined, "bold");
      pdf.text("Ankle Joint:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 6;

      pdf.autoTable({
        startY: y,
        head: [
          [
            "ROM & MMT",
            "Left ROM",
            "Right ROM",
            "Normal Range",
            "Left MMT",
            "Right MMT",
          ],
        ],
        body: [
          [
            "Dorsiflexion",
            report.ankle_left_rom_dorsiflexion || "-",
            report.ankle_right_rom_dorsiflexion || "-",
            "20",
            report.ankle_left_mmt_dorsiflexion || "-",
            report.ankle_right_mmt_dorsiflexion || "-",
          ],
          [
            "Plantarflexion",
            report.ankle_left_rom_plantarflexion || "-",
            report.ankle_right_rom_plantarflexion || "-",
            "50",
            report.ankle_left_mmt_plantarflexion || "-",
            report.ankle_right_mmt_plantarflexion || "-",
          ],
          [
            "Inversion",
            report.ankle_left_rom_inversion || "-",
            report.ankle_right_rom_inversion || "-",
            "35",
            report.ankle_left_mmt_inversion || "-",
            report.ankle_right_mmt_inversion || "-",
          ],
          [
            "Eversion",
            report.ankle_left_rom_eversion || "-",
            report.ankle_right_rom_eversion || "-",
            "20",
            report.ankle_left_mmt_eversion || "-",
            report.ankle_right_mmt_eversion || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      y = pdf.lastAutoTable.finalY + 7;

      // Ankle Special Tests
      pdf.setFont(undefined, "bold");
      pdf.text("Special Test:", 15, y);
      pdf.setFont(undefined, "normal");
      y += 2;

      pdf.autoTable({
        startY: y,
        head: [["", "Left", "Right"]],
        body: [
          [
            "Subtalar Tilt",
            report.ankle_left_subtalar_tilt || "-",
            report.ankle_right_subtalar_tilt || "-",
          ],
          [
            "Anterior drawer",
            report.ankle_left_anterior_drawer || "-",
            report.ankle_right_anterior_drawer || "-",
          ],
          [
            "Posterior drawer",
            report.ankle_left_posterior_drawer || "-",
            report.ankle_right_posterior_drawer || "-",
          ],
          [
            "Mid-tarsal joint",
            report.ankle_left_mid_tarsal_joint || "-",
            report.ankle_right_mid_tarsal_joint || "-",
          ],
          [
            "Knee to wall",
            report.ankle_left_knee_to_wall || "-",
            report.ankle_right_knee_to_wall || "-",
          ],
        ],
        styles: { fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220] },
        theme: "grid",
        margin: { left: 15, right: 15 },
      });

      // Footer
      pdf.setFontSize(10);
      pdf.text(`Generated: ${new Date().toLocaleDateString("en-GB")}`, 15, 285);

      return { pdfData: pdf, previewLink: previewContainer };
    },
    getIllnessReport() {
      const illnessData = {
        player_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getIllnessReport",
      };
      PlayerInjury.find(illnessData)
        .then((response) => {
          if (response.status === 200) {
            this.illnessReportData = response.data;
          }
        })
        .catch((error) => {
          console.error("Error fetching illness report:", error);
        });
    },
    createNewIllnessReport() {
      this.showPlayerIllnessModal = true;
      this.newIllness = {
        illness_type: "",
        other_illness: "",
        start_date: "",
        end_date: "",
        notes: "",
        status: "Active",
        created_at: new Date().toISOString().split("T")[0],
      };
    },
    async saveIllnessReport() {
      if (this.newIllness.id === undefined) {
        const illnessData = {
          ...this.newIllness,
          player_id: this.selectedUserValue,
          action: "saveIllnessReport",
        };
        try {
          const response = await PlayerInjury.find(illnessData);
          if (response.status === 200) {
            this.$toast.success("Illness report saved");
            // Optionally reset the form
            this.newIllness = {
              illness_type: "",
              other_illness: "",
              start_date: "",
              end_date: "",
              notes: "",
              status: "Active",
            };

            this.showPlayerIllnessModal = false;
            this.getIllnessReport();
          }
        } catch (error) {
          this.$toast.error("Failed to save illness report");
        }
      } else {
        const illnessData = {
          ...this.newIllness,
          player_id: this.selectedUserValue,
          action: "updateIllnessReport",
        };
        try {
          const response = await PlayerInjury.find(illnessData);
          if (response.status === 200) {
            this.$toast.success("Illness report updated");
            // Optionally reset the form
            this.newIllness = {
              illness_type: "",
              other_illness: "",
              start_date: "",
              end_date: "",
              notes: "",
              status: "Active",
            };

            this.showPlayerIllnessModal = false;
            this.getIllnessReport();
          }
        } catch (error) {
          this.$toast.error("Failed to update illness report");
        }
      }
    },
    viewMSKReport(report) {
      this.showReport = true;
      this.selectedMSKReport = report;
      this.showMskReportPDFModal = true;

      setTimeout(() => {
        let pdf = this.buildMSKReportPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    async deleteMSKReport(reportId) {
      this.selectedMSKReportId = reportId;

      const confirmed = await this.showConfirmDialog(
        "Are you sure you want to delete this report?",
        {
          title: "Confirm Deletion",
          okTitle: "Yes",
          cancelTitle: "No",
        },
      );

      if (confirmed) {
        const response = await PlayerInjury.find({
          action: "deleteMSKReport",
          id: this.selectedMSKReportId,
        });

        if (response.status === 200) {
          this.$toast.success("MSK report deleted");
          this.getplayerJointAssessmentData(); // Refresh the MSK data
        } else {
          this.$toast.error("Failed to delete MSK report");
        }
      }
    },
    getPhysioName(physioId) {
      let physio = this.allPhysios.find((physio) => physio.id === physioId);
      return physio ? physio.name : "Unknown Physio";
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    toggleVoiceRecording(field, typeOfInjuryInformation) {
      if (this.isRecording === field) {
        this.stopVoiceRecording();
      } else {
        this.startVoiceRecording(field, typeOfInjuryInformation);
      }
    },
    startVoiceRecording(field, typeOfInjuryInformation) {
      // Create a new SpeechRecognition instance for the field
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        this.$toast.error("Your browser does not support voice recording.");
        return;
      }

      const recognition = new SpeechRecognition();
      recognition.lang = "en-UK"; // Set language
      recognition.interimResults = false; // Only final results
      recognition.maxAlternatives = 1;

      // Event: When speech is recognized
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;

        // Ensure the field is initialized as a string before appending
        if (
          this[typeOfInjuryInformation][field] === undefined ||
          this[typeOfInjuryInformation][field] === null
        ) {
          this[typeOfInjuryInformation][field] = "";
        }

        const current = this[typeOfInjuryInformation][field] || "";
        this[typeOfInjuryInformation][field] =
          `${current}${current ? " " : ""}${transcript}`;
      };

      // Event: When recognition ends
      recognition.onend = () => {
        if (this.isRecording === field) {
          this.isRecording = null;
        }
      };

      // Event: Handle errors
      recognition.onerror = (event) => {
        if (event.error === "not-allowed") {
          this.$toast.error(
            "Microphone access is denied. Please enable it in your browser settings.",
          );
        } else {
          console.error("SpeechRecognition error:", event.error);
          this.$toast.error("An error occurred during voice recording.");
        }
        if (this.isRecording === field) {
          this.isRecording = null;
        }
      };

      // Start recognition
      recognition.start();
      this.isRecording = field;

      // Store the recognition instance for the field
      this.recognition = recognition;
    },
    stopVoiceRecording(field) {
      if (this.recognition && this.isRecording === field) {
        this.recognition.stop();
        this.isRecording = null;
      }
    },
    createNewMSKreport(maskReport) {
      if (maskReport !== undefined) {
        this.newMSKReport = maskReport;
      } else {
        this.newMSKReport = {
          player_id: "",
          team: "",
          past_medical_history: "",
          previous_injuries: "",

          // Hip ROM
          hip_left_rom_flexion: null,
          hip_right_rom_flexion: null,
          hip_left_rom_extension: null,
          hip_right_rom_extension: null,
          hip_left_rom_abduction: null,
          hip_right_rom_abduction: null,
          hip_left_rom_adduction: null,
          hip_right_rom_adduction: null,
          hip_left_rom_internal_rotation: null,
          hip_right_rom_internal_rotation: null,
          hip_left_rom_external_rotation: null,
          hip_right_rom_external_rotation: null,

          // Hip MMT
          hip_left_mmt_flexion: "",
          hip_right_mmt_flexion: "",
          hip_left_mmt_extension: "",
          hip_right_mmt_extension: "",
          hip_left_mmt_abduction: "",
          hip_right_mmt_abduction: "",
          hip_left_mmt_adduction: "",
          hip_right_mmt_adduction: "",
          hip_left_mmt_internal_rotation: "",
          hip_right_mmt_internal_rotation: "",
          hip_left_mmt_external_rotation: "",
          hip_right_mmt_external_rotation: "",

          // Hip Special Tests
          hip_left_fabers_test: "",
          hip_right_fabers_test: "",
          hip_left_obers_test: "",
          hip_right_obers_test: "",
          hip_left_ely_test: "",
          hip_right_ely_test: "",
          hip_left_piriformis_test: "",
          hip_right_piriformis_test: "",

          // Knee ROM
          knee_left_rom_flexion: null,
          knee_right_rom_flexion: null,
          knee_left_rom_extension: null,
          knee_right_rom_extension: null,

          // Knee MMT
          knee_left_mmt_flexion: "",
          knee_right_mmt_flexion: "",
          knee_left_mmt_extension: "",
          knee_right_mmt_extension: "",

          // Knee Special Tests
          knee_left_mcl: "",
          knee_right_mcl: "",
          knee_left_lcl: "",
          knee_right_lcl: "",
          knee_left_acl: "",
          knee_right_acl: "",
          knee_left_pcl: "",
          knee_right_pcl: "",
          knee_left_meniscus: "",
          knee_right_meniscus: "",
          knee_left_patellar_alignment: "",
          knee_right_patellar_alignment: "",

          // Ankle ROM
          ankle_left_rom_dorsiflexion: null,
          ankle_right_rom_dorsiflexion: null,
          ankle_left_rom_plantarflexion: null,
          ankle_right_rom_plantarflexion: null,
          ankle_left_rom_inversion: null,
          ankle_right_rom_inversion: null,
          ankle_left_rom_eversion: null,
          ankle_right_rom_eversion: null,

          // Ankle MMT
          ankle_left_mmt_dorsiflexion: "",
          ankle_right_mmt_dorsiflexion: "",
          ankle_left_mmt_plantarflexion: "",
          ankle_right_mmt_plantarflexion: "",
          ankle_left_mmt_inversion: "",
          ankle_right_mmt_inversion: "",
          ankle_left_mmt_eversion: "",
          ankle_right_mmt_eversion: "",

          // Ankle Special Tests
          ankle_left_subtalar_tilt: "",
          ankle_right_subtalar_tilt: "",
          ankle_left_anterior_drawer: "",
          ankle_right_anterior_drawer: "",
          ankle_left_posterior_drawer: "",
          ankle_right_posterior_drawer: "",
          ankle_left_mid_tarsal_joint: "",
          ankle_right_mid_tarsal_joint: "",
          ankle_left_knee_to_wall: "",
          ankle_right_knee_to_wall: "",
        };
      }
      this.showMskReportModal = true;
    },
    async saveMSKReport() {
      if (this.newMSKReport.id === undefined) {
        this.newMSKReport.player_id = this.selectedUserValue; // Set the player ID
        this.newMSKReport.club_id = this.userData.clubId; // Set the club ID
        this.newMSKReport.assessment_date = new Date()
          .toISOString()
          .split("T")[0]; // Set the current date as created date
        const userData = {
          ...this.newMSKReport,
          action: "saveMSKReport",
        };

        try {
          const response = await PlayerInjury.find(userData);
          if (response.status === 200) {
            this.$toast.success("MSK Report saved successfully");
            this.showMskReportModal = false;
            this.getplayerJointAssessmentData(); // Refresh the MSK data
          }
        } catch (error) {
          console.error("Error saving MSK Report:", error);
          this.$toast.error("Failed to save MSK Report");
        }
      } else {
        this.editMSKReport();
      }
    },

    // MSK Form Helper Methods
    toggleMskSection(section) {
      this.mskExpandedSections[section] = !this.mskExpandedSections[section];
    },
    expandAllSections() {
      this.allSectionsExpanded = !this.allSectionsExpanded;
      Object.keys(this.mskExpandedSections).forEach(key => {
        this.mskExpandedSections[key] = this.allSectionsExpanded;
      });
    },
    clearAllMSK() {
      const fields = Object.keys(this.newMSKReport);
      fields.forEach(field => {
        if (field !== 'id' && field !== 'player_id' && field !== 'club_id') {
          if (typeof this.newMSKReport[field] === 'number' || this.newMSKReport[field] === null) {
            this.newMSKReport[field] = null;
          } else {
            this.newMSKReport[field] = '';
          }
        }
      });
    },
    fillNormalRanges() {
      this.fillHipNormalROM();
      this.fillHipNormalMMT();
      this.fillHipNegativeTests();
      this.fillKneeNormalROM();
      this.fillKneeNormalMMT();
      this.fillKneeNegativeTests();
      this.fillAnkleNormalROM();
      this.fillAnkleNormalMMT();
      this.fillAnkleNegativeTests();
    },
    // Hip helpers
    fillHipNormalROM() {
      this.newMSKReport.hip_left_rom_flexion = 120;
      this.newMSKReport.hip_right_rom_flexion = 120;
      this.newMSKReport.hip_left_rom_extension = 30;
      this.newMSKReport.hip_right_rom_extension = 30;
      this.newMSKReport.hip_left_rom_abduction = 45;
      this.newMSKReport.hip_right_rom_abduction = 45;
      this.newMSKReport.hip_left_rom_adduction = 30;
      this.newMSKReport.hip_right_rom_adduction = 30;
      this.newMSKReport.hip_left_rom_internal_rotation = 45;
      this.newMSKReport.hip_right_rom_internal_rotation = 45;
      this.newMSKReport.hip_left_rom_external_rotation = 45;
      this.newMSKReport.hip_right_rom_external_rotation = 45;
    },
    fillHipNormalMMT() {
      this.newMSKReport.hip_left_mmt_flexion = '5/5';
      this.newMSKReport.hip_right_mmt_flexion = '5/5';
      this.newMSKReport.hip_left_mmt_extension = '5/5';
      this.newMSKReport.hip_right_mmt_extension = '5/5';
      this.newMSKReport.hip_left_mmt_abduction = '5/5';
      this.newMSKReport.hip_right_mmt_abduction = '5/5';
      this.newMSKReport.hip_left_mmt_adduction = '5/5';
      this.newMSKReport.hip_right_mmt_adduction = '5/5';
      this.newMSKReport.hip_left_mmt_internal_rotation = '5/5';
      this.newMSKReport.hip_right_mmt_internal_rotation = '5/5';
      this.newMSKReport.hip_left_mmt_external_rotation = '5/5';
      this.newMSKReport.hip_right_mmt_external_rotation = '5/5';
    },
    fillHipNegativeTests() {
      this.hipSpecialTests.forEach(test => {
        this.newMSKReport[test.leftKey] = 'Negative';
        this.newMSKReport[test.rightKey] = 'Negative';
      });
    },
    // Knee helpers
    fillKneeNormalROM() {
      this.newMSKReport.knee_left_rom_flexion = 140;
      this.newMSKReport.knee_right_rom_flexion = 140;
      this.newMSKReport.knee_left_rom_extension = 0;
      this.newMSKReport.knee_right_rom_extension = 0;
    },
    fillKneeNormalMMT() {
      this.newMSKReport.knee_left_mmt_flexion = '5/5';
      this.newMSKReport.knee_right_mmt_flexion = '5/5';
      this.newMSKReport.knee_left_mmt_extension = '5/5';
      this.newMSKReport.knee_right_mmt_extension = '5/5';
    },
    fillKneeNegativeTests() {
      this.kneeSpecialTests.forEach(test => {
        this.newMSKReport[test.leftKey] = 'Negative';
        this.newMSKReport[test.rightKey] = 'Negative';
      });
    },
    // Ankle helpers
    fillAnkleNormalROM() {
      this.newMSKReport.ankle_left_rom_dorsiflexion = 20;
      this.newMSKReport.ankle_right_rom_dorsiflexion = 20;
      this.newMSKReport.ankle_left_rom_plantarflexion = 50;
      this.newMSKReport.ankle_right_rom_plantarflexion = 50;
      this.newMSKReport.ankle_left_rom_inversion = 35;
      this.newMSKReport.ankle_right_rom_inversion = 35;
      this.newMSKReport.ankle_left_rom_eversion = 20;
      this.newMSKReport.ankle_right_rom_eversion = 20;
    },
    fillAnkleNormalMMT() {
      this.newMSKReport.ankle_left_mmt_dorsiflexion = '5/5';
      this.newMSKReport.ankle_right_mmt_dorsiflexion = '5/5';
      this.newMSKReport.ankle_left_mmt_plantarflexion = '5/5';
      this.newMSKReport.ankle_right_mmt_plantarflexion = '5/5';
      this.newMSKReport.ankle_left_mmt_inversion = '5/5';
      this.newMSKReport.ankle_right_mmt_inversion = '5/5';
      this.newMSKReport.ankle_left_mmt_eversion = '5/5';
      this.newMSKReport.ankle_right_mmt_eversion = '5/5';
    },
    fillAnkleNegativeTests() {
      this.ankleSpecialTests.forEach(test => {
        this.newMSKReport[test.leftKey] = 'Negative';
        this.newMSKReport[test.rightKey] = 'Negative';
      });
    },
    // Completion count helpers
    getHipCompletionCount() {
      const fields = [
        'hip_left_rom_flexion', 'hip_right_rom_flexion', 'hip_left_rom_extension', 'hip_right_rom_extension',
        'hip_left_rom_abduction', 'hip_right_rom_abduction', 'hip_left_rom_adduction', 'hip_right_rom_adduction',
        'hip_left_rom_internal_rotation', 'hip_right_rom_internal_rotation', 'hip_left_rom_external_rotation', 'hip_right_rom_external_rotation',
        'hip_left_mmt_flexion', 'hip_right_mmt_flexion', 'hip_left_mmt_extension', 'hip_right_mmt_extension',
        'hip_left_mmt_abduction', 'hip_right_mmt_abduction', 'hip_left_mmt_adduction', 'hip_right_mmt_adduction',
        'hip_left_mmt_internal_rotation', 'hip_right_mmt_internal_rotation', 'hip_left_mmt_external_rotation', 'hip_right_mmt_external_rotation'
      ];
      return fields.filter(f => this.newMSKReport[f] !== null && this.newMSKReport[f] !== '').length;
    },
    getHipCompletionClass() {
      const count = this.getHipCompletionCount();
      if (count === 24) return 'completion-full';
      if (count > 0) return 'completion-partial';
      return 'completion-empty';
    },
    getKneeCompletionCount() {
      const fields = [
        'knee_left_rom_flexion', 'knee_right_rom_flexion', 'knee_left_rom_extension', 'knee_right_rom_extension',
        'knee_left_mmt_flexion', 'knee_right_mmt_flexion', 'knee_left_mmt_extension', 'knee_right_mmt_extension',
        'knee_left_mcl', 'knee_right_mcl', 'knee_left_lcl', 'knee_right_lcl',
        'knee_left_acl', 'knee_right_acl', 'knee_left_pcl', 'knee_right_pcl',
        'knee_left_meniscus', 'knee_right_meniscus', 'knee_left_patellar_alignment', 'knee_right_patellar_alignment'
      ];
      return fields.filter(f => this.newMSKReport[f] !== null && this.newMSKReport[f] !== '').length;
    },
    getKneeCompletionClass() {
      const count = this.getKneeCompletionCount();
      if (count === 20) return 'completion-full';
      if (count > 0) return 'completion-partial';
      return 'completion-empty';
    },
    getAnkleCompletionCount() {
      const fields = [
        'ankle_left_rom_dorsiflexion', 'ankle_right_rom_dorsiflexion', 'ankle_left_rom_plantarflexion', 'ankle_right_rom_plantarflexion',
        'ankle_left_rom_inversion', 'ankle_right_rom_inversion', 'ankle_left_rom_eversion', 'ankle_right_rom_eversion',
        'ankle_left_mmt_dorsiflexion', 'ankle_right_mmt_dorsiflexion', 'ankle_left_mmt_plantarflexion', 'ankle_right_mmt_plantarflexion',
        'ankle_left_mmt_inversion', 'ankle_right_mmt_inversion', 'ankle_left_mmt_eversion', 'ankle_right_mmt_eversion',
        'ankle_left_subtalar_tilt', 'ankle_right_subtalar_tilt', 'ankle_left_anterior_drawer', 'ankle_right_anterior_drawer',
        'ankle_left_posterior_drawer', 'ankle_right_posterior_drawer', 'ankle_left_mid_tarsal_joint', 'ankle_right_mid_tarsal_joint',
        'ankle_left_knee_to_wall', 'ankle_right_knee_to_wall'
      ];
      return fields.filter(f => this.newMSKReport[f] !== null && this.newMSKReport[f] !== '').length;
    },
    getAnkleCompletionClass() {
      const count = this.getAnkleCompletionCount();
      if (count === 26) return 'completion-full';
      if (count > 0) return 'completion-partial';
      return 'completion-empty';
    },

    // MSK Dashboard Helper Methods
    getRomStatus(value, normal, movement) {
      if (!value || value === 0) return 'none';
      // Extension is special - 0 is normal for knee
      if (movement === 'extension' && normal === 0) {
        return Math.abs(value) <= 5 ? 'good' : (Math.abs(value) <= 10 ? 'warning' : 'danger');
      }
      const percentage = (value / normal) * 100;
      if (percentage >= 80) return 'good';
      if (percentage >= 60) return 'warning';
      return 'danger';
    },

    getMmtStatus(value) {
      if (!value || value === '-') return 'none';
      const grade = value.split('/')[0].replace('+', '').replace('-', '');
      const numGrade = parseInt(grade);
      if (numGrade >= 4) return 'good';
      if (numGrade >= 3) return 'warning';
      return 'danger';
    },

    getTestStatus(value) {
      if (!value || value === '-') return 'none';
      return value === 'Negative' ? 'good' : 'danger';
    },

    formatMovementName(movement) {
      return movement
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },

    getTrendIcon(trend) {
      if (trend === null) return '';
      if (trend > 0) return 'bi-arrow-up text-success';
      if (trend < 0) return 'bi-arrow-down text-danger';
      return 'bi-dash text-muted';
    },

    async editMSKReport() {
      const userData = {
        ...this.newMSKReport,
        action: "updateMSKReport",
      };

      try {
        const response = await PlayerInjury.find(userData);
        if (response.status === 200) {
          this.$toast.success("MSK Report updated successfully");
          this.showMskReportModal = false;
          this.getplayerJointAssessmentData(); // Refresh the MSK data
        }
      } catch (error) {
        console.error("Error saving MSK Report:", error);
        this.$toast.error("Failed to save MSK Report");
      }
    },
    generateUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16),
      );
    },
    filterMSKDataByUUID() { },
    async getplayerJointAssessmentData() {
      const userData = {
        player_id: this.selectedUserValue,
        action: "getplayerJointAssessmentData",
      };
      const response = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });
      if (response.data) {
        this.mskReportData = response.data;
        this.filterMSKDataByUUID();
      }
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;

      if (selectedTabValue === "reports-tab") {
        this.getplayerJointAssessmentData();
        this.getDocumentUploadsCall();
      }

      if (selectedTabValue === "illness-tab") {
        this.getIllnessReport();
      }
    },
    async updatePlayerInjuryReport(editInjuryReport) {
      const userData = {
        ...editInjuryReport,
        action: "updatePlayerInjuryReport",
      };
      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.loadAllInjuryReportDependencies();
        this.loadingStuff = false;
        this.$toast.success("Player injury report updated");
      }
    },
    async updatePlayerInjuryInformation() {
      const userData = {
        ...this.newInjuryInformation,
        action: "updatePlayerInjuryInformation",
      };
      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Player injury updated.") {
        this.loadAllInjuryReportDependencies();
        this.loadingStuff = false;

        this.$toast.success("Player injury report updated");

        // Auto-move to RTP Phase 4 when training status is "Partially"
        if (this.newInjuryInformation.training_status === 'Partially' && this.newInjuryInformation.id) {
          try {
            await ReturnToPlayService.setRTPPhase({
              injuryId: this.newInjuryInformation.id,
              playerId: this.newInjuryInformation.player_id || this.selectedUserValue,
              clubId: this.userData.clubId,
              targetPhase: 4,
            });
          } catch (err) {
            console.error('Auto-set RTP Phase 4 failed:', err);
          }
        }
      }
    },
    getInjuryStatusIcon(injuryStatus) {
      switch (injuryStatus) {
        case "Reciving treatment":
          return "heart"; // Example: activity icon
        case "Resting":
          return "moon"; // Example: moon icon
        case "Phased return":
          return "clock"; // Example: repeat icon
        case "Light training":
          return "check-circle"; // Example: check-circle icon
        case "Fully recoverd":
          return "check"; // Example: check icon
        default:
          return "question-circle"; // Default icon
      }
    },
    setInjuryStatusClass(injuryStatus) {
      switch (injuryStatus) {
        case "Reciving treatment":
          return "warning";
        case "Resting":
          return "info";
        case "Phased return":
          return "primary";
        case "Light training":
          return "recovering";
        case "Fully recoverd":
          return "success full-recoverd";
        default:
          return "";
      }
    },
    setTrainingAndPlayingStatusClass(status) {
      switch (status) {
        case 0:
          return "text-danger";
        case 1:
          return "text-success";
        default:
          return "";
      }
    },
    hidePlayerInjuryReportModel() {
      this.showPlayerInjuryModal = false;
      this.reSetNewInjuryInformation();
      this.getPlayerInjuryInformation();
      this.getPlayerInjuryReport();
      this.getAllPlayerInjuryReports();
      this.getDocumentUploadsCall();
    },
    loadAllInjuryReportDependencies() {
      this.selectedSeason = "current"; // Reset to current season
      this.showEditPlayerInjuryModal = false;
      this.reSetNewInjuryInformation();
      this.getPlayerInjuryInformation();
      this.getPlayerInjuryReport();
      this.getAllPlayerInjuryReports();
      this.getAllPhysios();
    },
    reSetNewInjuryInformation() {
      this.playerInjuryData = [];
      this.playerLiveInjurydata = [];
      this.playerHistoricInjuryData = [];
      this.newInjuryInformation = {
        injury_type: null,
        more_detail: null,
        return_time: null,
        injury_status: null,
        playing_status: 1,
        training_status: "Fully",
        activity_at_time: null,
        reasion_for_presentation: null,
        diagnosis: null,
        treatment: null,
        contact: null,
      };
    },
    resetPlayerinjuryNumbers() {
      this.playerInjuryHistoryAmounts = {
        headNeckInjury: 0,
        shoulderInjury: 0,
        armInjury: 0,
        wristAndHandInjury: 0,
        hipInjury: 0,
        groinInjury: 0,
        quadInjury: 0,
        hamstringInjury: 0,
        kneeInjury: 0,
        calfInjury: 0,
        ankleInjury: 0,
        footInjury: 0,
      };
    },
    populatePlayerInjuryNumbers() {
      this.resetPlayerinjuryNumbers();
      const injuryTypes = {
        "Head injury": "headNeckInjury",
        "Left Shoulder injury": "shoulderInjury",
        "Right Shoulder injury": "shoulderInjury",
        "Left Arm injury": "armInjury",
        "Right Arm injury": "armInjury",
        "Left Wrist and hand injury": "wristAndHandInjury",
        "Right Wrist and hand injury": "wristAndHandInjury",
        "Left Hip injury": "hipInjury",
        "Right Hip injury": "hipInjury",
        "Left Groin injury": "groinInjury",
        "Right Groin injury": "groinInjury",
        "Left Quad injury": "quadInjury",
        "Right Quad injury": "quadInjury",
        "Left hamstring injury": "hamstringInjury",
        "Right hamstring injury": "hamstringInjury",
        "Left Knee injury": "kneeInjury",
        "Right Knee injury": "kneeInjury",
        "Left Calf injury": "calfInjury",
        "Right Calf injury": "calfInjury",
        "Left ankle injury": "ankleInjury",
        "Right ankle injury": "ankleInjury",
        "Left Foot injury": "footInjury",
        "Right Foot injury": "footInjury",
      };

      this.allPlayerInjuryReports.forEach((injury) => {
        const injuryType = injuryTypes[injury.injury_type];
        if (injuryType) {
          this.playerInjuryHistoryAmounts[injuryType]++;
        }
      });
    },

    // ========== RTP Protocol Methods ==========
    openStartRTPModal(injury) {
      this.pendingRTPInjury = injury;
      this.rtpForm = {
        targetDate: '',
        restrictions: ''
      };
      this.showStartRTPModal = true;
    },

    async startRTPProtocol() {
      if (!this.pendingRTPInjury?.id) {
        this.$toast.error('No injury selected');
        return;
      }

      this.startingRTP = true;

      try {
        const params = {
          injuryId: this.pendingRTPInjury.id,
          playerId: this.selectedUserValue,
          clubId: this.userData.clubId,
          targetDate: this.rtpForm.targetDate || null,
          restrictions: this.rtpForm.restrictions || null
        };

        const response = await ReturnToPlayService.startRTPProtocol(params);

        if (response.data?.success) {
          this.$toast.success('RTP Protocol started successfully');
          this.showStartRTPModal = false;

          // Update the selectedInjury with RTP phase if in Full Details modal
          if (this.selectedInjury?.id === this.pendingRTPInjury.id) {
            this.selectedInjury = {
              ...this.selectedInjury,
              rtp_phase: 1,
              rtp_start_date: new Date().toISOString().split('T')[0]
            };
          }

          // Refresh injury data
          this.getPlayerInjuryInformation();
          this.getPlayerInjuryReport();
          this.getAllPlayerInjuryReports();

          this.pendingRTPInjury = null;
          this.rtpForm = { targetDate: '', restrictions: '' };
        } else {
          this.$toast.error(response.data?.message || 'Failed to start RTP Protocol');
        }
      } catch (error) {
        console.error('Error starting RTP:', error);
        this.$toast.error('Error starting RTP Protocol');
      } finally {
        this.startingRTP = false;
      }
    },

    onRTPPhaseUpdated(data) {
      // Refresh injury data when phase is updated
      this.getPlayerInjuryInformation();
      this.getPlayerInjuryReport();

      // Update selectedInjury if it matches
      if (this.selectedInjury?.id === data.injuryId) {
        this.selectedInjury = {
          ...this.selectedInjury,
          rtp_phase: data.newPhase,
          injury_status: data.injuryStatus || this.selectedInjury.injury_status
        };
      }

      this.$toast.info(`RTP Phase updated to Phase ${data.newPhase}`);
    },

    onRTPCompleted(data) {
      // Refresh injury data when RTP is completed
      this.getPlayerInjuryInformation();
      this.getPlayerInjuryReport();
      this.getAllPlayerInjuryReports();

      // Update selectedInjury if it matches
      if (this.selectedInjury?.id === data.injuryId) {
        this.selectedInjury = {
          ...this.selectedInjury,
          rtp_phase: 5,
          injury_status: 'Fully recoverd'
        };
      }

      this.$toast.success('🎉 RTP Protocol completed! Player cleared for return to play.');
    },
    // ========== End RTP Protocol Methods ==========

    // ========== Physio Appointments Methods ==========
    async loadPlayerPhysioAppointments() {
      if (!this.selectedUserData?.id) return;

      this.physioAppointmentsLoading = true;
      try {
        const response = await PhysioCalendarService.getPlayerAppointments({
          player_id: this.selectedUserData.id
        });
        // API returns array directly
        if (Array.isArray(response.data)) {
          this.playerPhysioAppointments = response.data;
        } else if (response.data?.appointments) {
          this.playerPhysioAppointments = response.data.appointments;
        } else {
          this.playerPhysioAppointments = [];
        }
      } catch (error) {
        console.error('Error loading player physio appointments:', error);
        this.playerPhysioAppointments = [];
      } finally {
        this.physioAppointmentsLoading = false;
      }
    },

    formatAppointmentDay(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.getDate();
    },

    formatAppointmentMonth(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-GB', { month: 'short' });
    },

    formatAppointmentTime(timeStr) {
      if (!timeStr) return '';
      const [hours, minutes] = timeStr.split(':');
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? 'pm' : 'am';
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minutes}${ampm}`;
    },
    // ========== End Physio Appointments Methods ==========

    async savePlayerInjuryReport() {
      const userData = {
        ...this.newInjuryInformation,
        player_id: this.selectedUserValue,
        clubId: this.userData.clubId,
        created_date: new Date().toISOString().split("T")[0],
        action: "savePlayerInjuryReport",
      };
      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        // Parse response data - handle both parsed JSON and string responses
        let responseData = responce.data;
        if (typeof responseData === 'string') {
          try {
            responseData = JSON.parse(responseData);
          } catch (e) {
            console.warn('Could not parse injury save response as JSON:', responseData);
            responseData = {};
          }
        }

        // Get the newly created injury ID from response
        const newInjuryId = responseData?.id || responseData?.insertId;

        this.getPlayerInjuryInformation();
        this.getPlayerInjuryReport();
        this.getAllPlayerInjuryReports();
        this.getDocumentUploadsCall();

        const savedInjuryInfo = { ...this.newInjuryInformation };
        this.reSetNewInjuryInformation();
        this.loadingStuff = false;

        this.showPlayerInjuryModal = false;
        this.showAllplayerInjuryReportsModal = false;

        this.$toast.success("Player injury report saved");

        // Auto-start RTP protocol at Phase 1 for injuries that are not fully recovered
        if (savedInjuryInfo.injury_status !== 'Fully recoverd' && newInjuryId) {
          try {
            const rtpResponse = await ReturnToPlayService.startRTPProtocol({
              injuryId: newInjuryId,
              playerId: this.selectedUserValue,
              clubId: this.userData.clubId,
              targetDate: null,
              restrictions: null,
            });

            if (rtpResponse.data?.success) {
              this.$toast.info('RTP Protocol auto-started at Phase 1 (Acute/Rest)');
              // Refresh injury data to reflect RTP phase
              this.getPlayerInjuryInformation();
            } else {
              console.warn('Auto-start RTP response:', rtpResponse.data);
            }
          } catch (err) {
            console.error('Auto-start RTP failed:', err);
          }
        } else if (!newInjuryId) {
          console.warn('Could not auto-start RTP: no injury ID returned from save response', responce.data);
        }
      }
    },
    async getPlayerInjuryInformation() {
      this.playerInjuryData = [];
      this.playerLiveInjurydata = [];
      this.playerHistoricInjuryData = [];
      const userData = {
        player_id: this.selectedUserValue,
        year: this.currentPlayingSeason,
        action: "getPlayerInjuryInformation",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.playerInjuryData = responce.data;
        this.setLiveInjuryData();
        this.setHistoricInjuryData();
      }
    },
    setHistoricInjuryData() {
      this.playerHistoricInjuryData = this.playerInjuryData.filter(
        (injury) => injury.injury_status === "Fully recoverd",
      );
    },
    setLiveInjuryData() {
      this.playerLiveInjurydata = this.playerInjuryData.filter(
        (injury) => injury.injury_status !== "Fully recoverd",
      );
    },
    async getPlayerInjuryReport() {
      this.playerInjuryData = [];
      this.playerLiveInjurydata = [];
      this.playerHistoricInjuryData = [];
      const userData = {
        player_id: this.selectedUserValue,
        year: this.currentPlayingSeason,
        action: "getPlayerInjuryReport",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.playerInjuryReportsData = responce.data;
      }
    },
    async getAllPlayerInjuryReports() {
      const userData = {
        player_id: this.selectedUserValue,
        action: "getAllPlayerInjuryReports",
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.allPlayerInjuryReports = responce.data;
        this.populatePlayerInjuryNumbers();
      }
    },
    async selectInjuryReportView(injury) {
      this.editInjuryReport = injury;
      await this.getPhysioDocumentUploadsForInjury(injury.id);
    },
    async getPhysioDocumentUploadsForInjury(playerInjuryReportId) {
      const userData = {
        action: "getPhysioDocumentUploadsForInjury",
        user_id: this.selectedUserValue,
        playerInjuryReportId: playerInjuryReportId,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.reportDocuments = response.data;
      }
    },
    formatDateForHuman(date) {
      return new Date(date).toLocaleDateString("en-GB"); // Replace with your actual date formatting logic
    },
    showDownloadFile() {
      // Implement the logic to download the file
    },
    showAllInjuryReports(mainInjury, id) {
      if (mainInjury === null) {
        mainInjury = this.allPlayerInjuryReports.find(
          (report) => report.id === id,
        );
      }
      this.editInjuryReport = {};
      this.selectedInjury = mainInjury;
      this.selectedInjuryReports = [];
      this.selectedInjuryReports = this.playerInjuryReportsData.filter(
        (report) => report.injury_information_id === mainInjury.id,
      );
      this.getDocumentUploadsCall();
      this.loadPlayerPhysioAppointments();
      this.showModal("allplayerInjuryReportsModal");
    },
    async getDocumentUploadsCall() {
      const userData = {
        action: "getDocumentUploadsByCategoryandUser",
        user_id: this.selectedUserData.id,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.uploadedDocuments = response.data;

        console.log("Uploaded Documents:", this.uploadedDocuments);
        this.getPlayerInjuryInformation();
        this.getPlayerInjuryReport();
        this.mskReportDocuments = this.uploadedDocuments.filter(
          (doc) => doc.category === "msk-report",
        );
        console.log("MSK Report Documents:", this.mskReportDocuments);
      }
    },
    editInjuryModal(modelId, injuryData) {
      console.log("Editing Injury Data:", injuryData);
      this.newInjuryInformation = injuryData;
      this.showModal(modelId);
    },
    async deletePlayerInjuryReport(id) {
      this.loadingStuff = true;
      const userData = {
        id: id,
        action: "deletePlayerInjuryReport",
      };
      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Injury Report removed") {
        this.reSetNewInjuryInformation();
        this.getPlayerInjuryInformation();
        this.getPlayerInjuryReport();
        this.loadingStuff = false;

        this.$toast.success("Player injury report removed");
      }
    },
    download_csv(data, sensor) {
      let csvHeader = Object.keys(data[0]).join(",") + "\n"; // header row
      let csvBody = data.map((row) => Object.values(row).join(",")).join("\n");

      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvHeader + csvBody);
      hiddenElement.target = "_blank";
      hiddenElement.download = sensor + ".csv";
      hiddenElement.click();
    },
    openPlayerInjuryModal(modelId, selectedInjury) {
      this.reSetNewInjuryInformation();
      if (selectedInjury !== undefined) {
        this.newInjuryInformation.id = selectedInjury.id;
        this.newInjuryInformation.injury_type = selectedInjury.injury_type;
        this.newInjuryInformation.injury_status = selectedInjury.injury_status;
        this.newInjuryInformation.player_id = selectedInjury.player_id;
        this.newInjuryInformation.more_detail = selectedInjury.more_detail;
        this.newInjuryInformation.diagnosis = selectedInjury.diagnosis;
        this.newInjuryInformation.contact = selectedInjury.contact;
        this.newInjuryInformation.playing_status =
          selectedInjury.playing_status;
        this.newInjuryInformation.training_status =
          selectedInjury.training_status;
        this.newInjuryInformation.activity_at_time =
          selectedInjury.activity_at_time;
        this.newInjuryInformation.reasion_for_presentation =
          selectedInjury.reasion_for_presentation;
        this.newInjuryInformation.treatment = selectedInjury.treatment;
        this.newInjuryInformation.return_time = selectedInjury.return_time;
        this.newInjuryInformation.physio_id = selectedInjury.physio_id;
      }
      this.showModal(modelId);
    },
    // ========== Simplified Add Treatment Record Methods ==========
    openAddTreatmentModal() {
      this.newTreatmentRecord = {
        treatment: '',
        physio_id: this.userData.id || ''
      };
      this.showAddTreatmentModal = true;
    },
    async saveTreatmentRecord() {
      if (!this.newTreatmentRecord.treatment) {
        this.$toast.error('Please enter treatment details');
        return;
      }

      const treatmentData = {
        injury_information_id: this.selectedInjury.id,
        player_id: this.selectedUserValue,
        clubId: this.userData.clubId,
        treatment: this.newTreatmentRecord.treatment,
        physio_id: this.newTreatmentRecord.physio_id || null,
        created_date: new Date().toISOString().split("T")[0],
        // Copy existing injury details for the report record
        injury_type: this.selectedInjury.injury_type,
        injury_status: this.selectedInjury.injury_status,
        return_time: this.selectedInjury.return_time,
        activity_at_time: this.selectedInjury.activity_at_time,
        reasion_for_presentation: 'Continuation of treatment',
        diagnosis: this.selectedInjury.diagnosis,
        playing_status: this.selectedInjury.playing_status,
        training_status: this.selectedInjury.training_status,
        action: "addTreatmentRecord",
      };

      try {
        const response = await PlayerInjury.find(treatmentData);

        if (response.status === 200) {
          this.$toast.success("Treatment record saved");
          this.showAddTreatmentModal = false;

          // Refresh the treatment records list
          this.getPlayerInjuryReport();

          // Update the selected injury reports in the current view
          setTimeout(() => {
            this.selectedInjuryReports = this.playerInjuryReportsData.filter(
              (report) => report.injury_information_id === this.selectedInjury.id
            );
          }, 500);
        }
      } catch (error) {
        console.error('Error saving treatment record:', error);
        this.$toast.error('Failed to save treatment record');
      }
    },
    // ========== End Simplified Add Treatment Record Methods ==========
    showModal(modelId) {
      // Map modal IDs to boolean properties
      const modalMap = {
        playerInjuryModal: () => (this.showPlayerInjuryModal = true),
        editPlayerInjuryModal: () => (this.showEditPlayerInjuryModal = true),
        allplayerInjuryReportsModal: () =>
          (this.showAllplayerInjuryReportsModal = true),
        mskReportModal: () => (this.showMskReportModal = true),
        mskReportPDFModal: () => (this.showMskReportPDFModal = true),
        playerIllnessReportPDFModal: () =>
          (this.showPlayerIllnessReportPDFModal = true),
        playerIllnessModal: () => (this.showPlayerIllnessModal = true),
      };
      if (modalMap[modelId]) {
        modalMap[modelId]();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.season-selector-wrapper {
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.season-selector {
  .btn-group {
    width: 100%;

    .btn {
      flex: 1;
      font-weight: 500;

      &.btn-primary {
        background-color: #47a9f9;
        border-color: #47a9f9;
      }

      &.btn-outline-primary {
        color: #47a9f9;
        border-color: #47a9f9;

        &:hover {
          background-color: #47a9f9;
          border-color: #47a9f9;
        }
      }
    }
  }
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #47a9f9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-state {
  padding: 2rem;
  margin: 1rem 0;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.mskReportPDFDocuments {
  margin-top: 1rem;
}

/* Confirmation Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-dialog {
  background: white;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  max-height: 120vh;
  overflow-y: auto;
}

.modal-content {
  background: white;
  border-radius: 0.375rem;
  height: 100vh;
  overflow: scroll;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem !important;
  border-bottom: 1px solid #dee2e6 !important;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
}

.btn-close:hover {
  color: #000;
}

.modal-body {
  padding: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
}

.btn {
  padding: 0.375rem 0.75rem;
  margin: 0;
  font-size: 1rem;
  border-radius: 0.375rem;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.btn-secondary {
  color: #6c757d;
  background-color: #f8f9fa;
  border-color: #6c757d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}

/* MSK Dashboard Styles */
.msk-dashboard {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  overflow: hidden;

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    background: #d9d9d9;
    color: white;
    flex-wrap: wrap;
    gap: 0.75rem;

    h3 {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      i {
        font-size: 1.4rem;
      }
    }

    .assessment-date {
      font-size: 0.9rem;
      opacity: 0.95;

      .report-count {
        opacity: 0.8;
        margin-left: 0.5rem;
      }
    }
  }

  .dashboard-overview {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
    padding: 1.5rem;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
  }

  .overview-card {
    background: white;
    border-radius: 10px;
    padding: 1.25rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .card-icon {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.4rem;
      color: white;
    }

    &.overall-score .card-icon {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }

    &.special-tests .card-icon {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    }

    &.medical-history .card-icon {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    }

    &.previous-injuries .card-icon {
      background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    }

    .card-content {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .card-label {
      font-size: 0.8rem;
      font-weight: 600;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .card-value {
      font-size: 1.75rem;
      font-weight: 700;
      line-height: 1.2;

      &.good {
        color: #28a745;
      }

      &.warning {
        color: #ffc107;
      }

      &.danger {
        color: #dc3545;
      }
    }

    .card-sublabel {
      font-size: 0.75rem;
      color: #6c757d;
    }

    .card-text {
      font-size: 0.9rem;
      color: #495057;
      line-height: 1.4;
      max-height: 3.6rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .score-bar {
      height: 6px;
      background: #e9ecef;
      border-radius: 3px;
      overflow: hidden;
      margin-top: auto;

      .score-fill {
        height: 100%;
        border-radius: 3px;
        transition: width 0.5s ease;

        &.good {
          background: linear-gradient(90deg, #28a745, #20c997);
        }

        &.warning {
          background: linear-gradient(90deg, #ffc107, #fd7e14);
        }

        &.danger {
          background: linear-gradient(90deg, #dc3545, #c82333);
        }
      }
    }
  }

  .joint-sections {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .joint-card {
    background: white;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    border: 1px solid #e9ecef;

    .joint-header {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 1rem 1.25rem;
      color: white;
      font-weight: 600;

      &.hip {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }

      &.knee {
        background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
      }

      &.ankle {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      }

      i {
        font-size: 1.25rem;
      }

      h4 {
        margin: 0;
        font-size: 1.1rem;
      }
    }

    .joint-content {
      padding: 1.25rem;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }

    .rom-section,
    .mmt-section,
    .tests-section {
      h5 {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: #495057;
        margin-bottom: 1rem;
        padding-bottom: 0.5rem;
        border-bottom: 2px solid #e9ecef;

        i {
          color: #667eea;
        }
      }
    }

    .rom-grid,
    .mmt-grid,
    .tests-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 0.75rem;
    }

    .rom-item,
    .mmt-item,
    .test-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 1rem;
      background: #f8f9fa;
      border-radius: 8px;
      flex-wrap: wrap;
      gap: 0.5rem;

      .movement-name,
      .test-name {
        font-weight: 500;
        color: #333;
        font-size: 0.9rem;
        min-width: 120px;
      }

      .values-row {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;
      }

      .value-cell {
        padding: 0.35rem 0.65rem;
        border-radius: 6px;
        font-size: 0.85rem;
        font-weight: 600;
        min-width: 70px;
        text-align: center;
        background: #e9ecef;
        color: #495057;

        &.good {
          background: rgba(40, 167, 69, 0.15);
          color: #28a745;
        }

        &.warning {
          background: rgba(255, 193, 7, 0.2);
          color: #856404;
        }

        &.danger {
          background: rgba(220, 53, 69, 0.15);
          color: #dc3545;
        }

        &.none {
          background: #f8f9fa;
          color: #adb5bd;
        }

        i {
          margin-left: 0.25rem;
          font-size: 0.75rem;
        }
      }

      .normal-value {
        font-size: 0.75rem;
        color: #6c757d;
        font-style: italic;
      }
    }
  }
}

/* MSK Dashboard Responsive */
@media (max-width: 768px) {
  .msk-dashboard {
    .dashboard-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 1rem;

      h3 {
        font-size: 1.1rem;
      }

      .assessment-date {
        font-size: 0.8rem;
      }
    }

    .dashboard-overview {
      grid-template-columns: 1fr;
      padding: 1rem;
    }

    .joint-sections {
      padding: 1rem;
    }

    .rom-grid,
    .mmt-grid,
    .tests-grid {
      grid-template-columns: 1fr;
    }

    .rom-item,
    .mmt-item,
    .test-item {
      flex-direction: column;
      align-items: flex-start;

      .movement-name,
      .test-name {
        margin-bottom: 0.5rem;
      }

      .values-row {
        width: 100%;
        justify-content: flex-start;
      }
    }
  }
}

@media (max-width: 480px) {
  .msk-dashboard {
    .overview-card {
      padding: 1rem;

      .card-value {
        font-size: 1.5rem;
      }
    }

    .joint-card {
      .joint-header {
        padding: 0.75rem 1rem;

        h4 {
          font-size: 1rem;
        }
      }

      .joint-content {
        padding: 1rem;
      }
    }

    .rom-item,
    .mmt-item,
    .test-item {
      padding: 0.6rem 0.75rem;

      .value-cell {
        min-width: 60px;
        padding: 0.3rem 0.5rem;
        font-size: 0.8rem;
      }
    }
  }
}

.msk-report-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  padding: 1rem;

  .joint-section {
    border: 1px solid #dee2e6;
    flex: 1;
    padding: 1rem;
    min-width: 13rem;
  }
}

/* Improved MSK Form Styles */
.msk-form-improved {
  max-width: 100%;
}

.msk-player-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;

  .player-info-compact {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i {
      font-size: 2rem;
    }

    strong {
      font-size: 1.1rem;
      display: block;
    }

    .team-badge {
      font-size: 0.85rem;
      opacity: 0.9;
      background: rgba(255, 255, 255, 0.2);
      padding: 0.2rem 0.5rem;
      border-radius: 4px;
      display: inline-block;
      margin-top: 0.25rem;
    }
  }

  .msk-progress-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.15);
    padding: 0.5rem 1rem;
    border-radius: 8px;

    .progress-label {
      font-size: 0.85rem;
      opacity: 0.9;
    }

    .progress-bar-wrapper {
      width: 100px;
      height: 8px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 4px;
      overflow: hidden;

      .progress-bar-fill {
        height: 100%;
        background: #4ade80;
        transition: width 0.3s ease;
        border-radius: 4px;
      }
    }

    .progress-percent {
      font-weight: 600;
      min-width: 40px;
      text-align: right;
    }
  }
}

.msk-quick-actions {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  .btn {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.85rem;
  }
}

.msk-section-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .msk-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    background: #f8fafc;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f1f5f9;
    }

    .section-title-wrapper {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      i {
        color: #64748b;
        font-size: 1.1rem;
      }

      h4 {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        color: #334155;
      }

      .section-completion {
        font-size: 0.75rem;
        padding: 0.2rem 0.5rem;
        border-radius: 12px;
        font-weight: 500;

        &.completion-empty {
          background: #fee2e2;
          color: #dc2626;
        }

        &.completion-partial {
          background: #fef3c7;
          color: #d97706;
        }

        &.completion-full {
          background: #dcfce7;
          color: #16a34a;
        }
      }
    }

    > i {
      color: #94a3b8;
      transition: transform 0.2s;
    }
  }

  .msk-section-body {
    padding: 1.25rem;
    border-top: 1px solid #e2e8f0;
  }
}

.msk-subsection {
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  .subsection-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e2e8f0;

    h5 {
      margin: 0;
      font-size: 0.9rem;
      font-weight: 600;
      color: #475569;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      i {
        color: #64748b;
      }
    }

    .btn-link {
      font-size: 0.8rem;
      padding: 0.2rem 0.5rem;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.msk-input-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  thead {
    th {
      padding: 0.5rem 0.75rem;
      background: #f1f5f9;
      font-size: 0.8rem;
      font-weight: 600;
      color: #475569;
      text-align: left;
      border-bottom: 2px solid #e2e8f0;

      &:first-child {
        border-radius: 6px 0 0 0;
      }

      &:last-child {
        border-radius: 0 6px 0 0;
        text-align: center;
      }
    }
  }

  tbody {
    tr {
      &:hover {
        background: #f8fafc;
      }

      &:last-child td {
        border-bottom: none;
      }
    }

    td {
      padding: 0.5rem 0.75rem;
      border-bottom: 1px solid #f1f5f9;
      font-size: 0.9rem;
      vertical-align: middle;

      &:first-child {
        font-weight: 500;
        color: #334155;
        white-space: nowrap;
      }

      input[type="number"] {
        width: 100%;
        max-width: 80px;
        padding: 0.4rem 0.5rem;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 0.9rem;
        text-align: center;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        &::placeholder {
          color: #9ca3af;
          font-size: 0.8rem;
        }
      }

      &.normal-range {
        color: #64748b;
        font-size: 0.8rem;
        text-align: center;
        font-style: italic;
      }
    }
  }
}

.mmt-select {
  width: 100%;
  max-width: 80px;
  padding: 0.4rem 0.3rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.85rem;
  background: white;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
}

.special-tests-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.special-test-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.75rem;
  background: #f8fafc;
  border-radius: 8px;
  flex-wrap: wrap;
  gap: 0.5rem;

  .test-name {
    font-weight: 500;
    color: #334155;
    font-size: 0.9rem;
    min-width: 140px;
  }

  .test-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;

    .side-label {
      font-size: 0.75rem;
      font-weight: 600;
      color: #64748b;
      min-width: 15px;
    }

    .btn-group {
      .btn {
        padding: 0.3rem 0.6rem;
        font-weight: 600;
        font-size: 0.9rem;
        min-width: 32px;

        &.btn-success {
          background-color: #16a34a;
          border-color: #16a34a;
        }

        &.btn-danger {
          background-color: #dc2626;
          border-color: #dc2626;
        }

        &.btn-outline-secondary {
          color: #6b7280;
          border-color: #d1d5db;

          &:hover {
            background-color: #f3f4f6;
          }
        }
      }
    }
  }
}

.msk-submit-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 2px solid #e2e8f0;
  text-align: center;

  .btn {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border-radius: 8px;

    &.btn-success {
      background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #15803d 0%, #166534 100%);
      }
    }
  }
}

/* Responsive adjustments for MSK form */
@media (max-width: 768px) {
  .msk-player-header {
    flex-direction: column;
    text-align: center;

    .player-info-compact {
      flex-direction: column;
      text-align: center;
    }
  }

  .msk-input-table {
    thead th:last-child {
      display: none;
    }

    tbody td.normal-range {
      display: none;
    }
  }

  .special-test-row {
    .test-name {
      width: 100%;
      margin-bottom: 0.25rem;
    }

    .test-buttons {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

.modal-container {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    border: 0;
    width: 100%;
    height: 50rem;
  }
}

.injury-details.large-text-area {
  border: 1px solid #bdbdbe;
  padding: 1rem;
  width: 100%;
  border-radius: 4px;
  margin: 0 !important;
}

.playing-training-status.text-danger {
  background: #dc3545;
  color: white !important;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.playing-training-status.text-success {
  background: #28a745;
  color: white !important;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.playing-training-status.text-warning {
  background: #ffc107;
  color: white !important;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.injury-information-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;

  h3 {
    width: 100%;
    margin-bottom: 1rem;
  }

  .player-photo-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }

  .user-photo-info img {
    border-radius: 100px;
    border: 1px solid #c3cdd5;
    width: 150px;
    height: 150px;
  }

  .injury-details {
    min-width: 10%;

    p:first-of-type {
      font-weight: normal;
    }

    p {
      margin: 0;
    }
  }

  .injury-information {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 100%;

    .information-box {
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;
      flex: 1;
    }

    .document-wrapper {
      flex: 1;
    }
  }
}

.form__input {
  font-weight: normal;
}

.playing-training-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.radio-box-group {
  display: flex;
  gap: 1rem;
}

.radio-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border: 2px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  font-weight: bold;
  color: #333;
  background-color: #f9f9f9;
}

.radio-box:hover {
  border-color: #007bff;
}

.radio-box.green.selected {
  border-color: #08a10f;
  background-color: rgb(2, 217, 74);
  color: white;
}

.radio-box.amber.selected {
  border-color: $secondary-color;
  background-color: #f2c94c;
  color: white;
}

.radio-box.red.selected {
  border-color: #a10812;
  background-color: #ff2f00;
  color: white;
}

.radio-box span {
  pointer-events: none;
  /* Prevent text from interfering with clicks */
}

.radio-box input[type="radio"] {
  display: none;
  /* Hide the default radio button */
}

.reports-view {
  flex: 1;
  border: 1px solid #dee2e6;
  padding: 2rem;
  border-radius: 4px;

  .uploaded-documents-wrapper {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background-color: #f8f9fa;
    margin-bottom: 2rem;
  }
}

.voice-record-button {
  width: 10rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  b-icon {
    font-size: 1.2rem;
  }
}

.tabs-wrapper .tab-content {
  padding: 1rem 0;
}

.injury-reports-wrapper {
  text-align: center;

  button {
    padding: 1rem;
    display: block;
  }
}

.player-performance-review-info,
.player-performance-review-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  gap: 3rem;
  border-bottom: 1px solid #a9b3bc;
  padding-bottom: 2rem;
  width: 100%;
}

ul.injury-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  span {
    font-weight: bold;
    float: right;
    margin-left: 1rem;
  }
}

.full-recoverd {
  background-color: #d4edda;
}

.document-upload-physio-report {
  border: 1px solid #dee2e6;
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f8f9fa;
}

.document {
  max-width: 14rem;
  text-align: center;
  padding: 1rem;
  margin: 1rem;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
  border: 1px solid transparent;

  &:hover,
  &:focus {
    border: 1px solid $secondary-color;
  }

  h3 {
    margin-top: 1rem;
    font-size: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-transform: inherit;
  }

  img {
    width: 40%;
  }
}

.attached-reports-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
  margin-top: 2rem;
  border-top: 1px dashed #dee2e6;
  padding-top: 2rem;
}

.status-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.injury-status {
  flex: 1;
  min-width: 12rem !important;

  .playing-training-status.text-success,
  .playing-training-status.text-warning,
  .playing-training-status.text-danger {
    padding: 1rem;
    text-align: center;
    display: block;
  }

  .recovering {
    background: #dba716;
    padding: 1rem;
    border-radius: 4px;
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
  }

  .full-recoverd,
  .success {
    background: #28a745;
    padding: 1rem;
    border-radius: 4px;
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
  }

  .warning {
    background: #dc3545;
    padding: 1rem;
    border-radius: 4px;
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
  }

  .info {
    background: #17a2b8;
    padding: 1rem;
    border-radius: 4px;
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
  }

  .primary {
    background: #dbdb00;
    padding: 1rem;
    border-radius: 4px;
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
  }
}

.buttons-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  button {
    background: white;
    padding: 1rem;
  }

  button.btn.btn-outline-warning {

    &:hover,
    &:focus {
      background: #ffc109;
      color: white;
    }
  }

  button.btn.btn-outline-success {

    &:hover,
    &:focus {
      background: #28a745;
      color: white;
    }
  }
}

/* Season Comparison Styles */
.comparison-active-indicator {
  padding: 0.75rem 1rem;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 0.375rem;
  color: #155724;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.season-comparison-view {
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
}

.comparison-header {
  text-align: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #007bff;
}

.comparison-header h3 {
  color: #007bff;
  margin: 0;
  font-weight: 600;
}

.comparison-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.metric-card {
  background: white;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.metric-card h4 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.metric-comparison {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.75rem;
}

.season-metric {
  text-align: center;
}

.season-label {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.metric-value {
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  color: #212529;
}

.trend-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
}

.trend-better {
  color: #28a745;
  font-weight: 600;
}

.trend-worse {
  color: #dc3545;
  font-weight: 600;
}

.trend-same {
  color: #6c757d;
  font-weight: 600;
}

.side-by-side-comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.season-column {
  background: white;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.season-column h4 {
  margin: 0 0 1.5rem 0;
  color: #007bff;
  font-weight: 600;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
}

.comparison-section {
  margin-bottom: 2rem;
}

.comparison-section:last-child {
  margin-bottom: 0;
}

.comparison-section h5 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  border-left: 3px solid #007bff;
}

.comparison-table-wrapper {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.comparison-table th,
.comparison-table td {
  padding: 0.5rem;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.comparison-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  position: sticky;
  top: 0;
  z-index: 1;
}

.comparison-table tbody tr:hover {
  background-color: #f8f9fa;
}

.empty-comparison {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-style: italic;
}

@media (max-width: 768px) {

  /* Season Selector Responsive */
  .season-selector-wrapper {
    padding: 0.75rem;
  }

  .season-selector {
    flex-direction: column;
    gap: 0.75rem;

    .btn-group {
      flex-direction: column;

      .btn {
        width: 100%;
        border-radius: 0.375rem !important;
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .comparison-toggle-wrapper {
    width: 100%;

    .comparison-toggle {
      width: 100%;
    }
  }

  .comparison-active-indicator {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
  }

  .comparison-metrics {
    grid-template-columns: 1fr;
  }

  .side-by-side-comparison {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .metric-comparison {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .trend-indicator {
    margin: 0.5rem 0;
  }
}

@media (max-width: 480px) {
  .season-selector-wrapper {
    padding: 0.5rem;
    margin-bottom: 0.75rem;
  }

  .season-selector {
    gap: 0.5rem;

    .btn-group .btn {
      font-size: 0.85rem;
      padding: 0.5rem 0.75rem;
    }
  }

  .comparison-toggle {
    font-size: 0.85rem;
    padding: 0.5rem 0.75rem;
  }

  .comparison-active-indicator {
    font-size: 0.8rem;
  }

  .season-comparison-view {
    padding: 0.75rem;
  }

  .metric-card {
    padding: 0.75rem;

    h4 {
      font-size: 0.9rem;
    }
  }

  .metric-value {
    font-size: 1.25rem;
  }

  .season-column {
    padding: 0.75rem;

    h4 {
      font-size: 0.9rem;
    }
  }

  .summary-item {
    padding: 0.5rem;
    font-size: 0.85rem;
  }
}

// RTP Phase Badge Styles
.rtp-column {
  text-align: center;

  .badge {
    display: inline-block;
    padding: 0.35em 0.65em;
    font-size: 0.75em;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.375rem;
  }

  .rtp-phase-1 {
    background-color: #dc3545;
    color: white;
  }

  .rtp-phase-2 {
    background-color: #fd7e14;
    color: white;
  }

  .rtp-phase-3 {
    background-color: #ffc107;
    color: #212529;
  }

  .rtp-phase-4 {
    background-color: #20c997;
    color: white;
  }

  .rtp-phase-5 {
    background-color: #198754;
    color: white;
  }
}

// RTP Protocol Section Styles
.rtp-protocol-section {
  .start-rtp-section {
    text-align: center;
  }
}

// Physio Appointments Section Styles
.physio-appointments-section {
  .physio-appointments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    h4 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 1.1rem;

      i {
        color: #007bff;
      }
    }
  }

  .empty-appointments-state {
    text-align: center;
    padding: 2rem;
    color: #6c757d;

    i {
      font-size: 2.5rem;
      opacity: 0.4;
      margin-bottom: 0.75rem;
      display: block;
    }

    p {
      margin-bottom: 1rem;
      font-size: 0.9rem;
    }
  }

  .physio-appointments-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .physio-appointment-card {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: white;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &.confirmed,
    &.booked {
      border-left: 4px solid #28a745;
    }

    &.pending {
      border-left: 4px solid #ffc107;
    }

    &.cancelled {
      border-left: 4px solid #dc3545;
      opacity: 0.7;
    }
  }

  .apt-date-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background: #e9ecef;
    border-radius: 8px;
    flex-shrink: 0;

    .apt-day {
      font-size: 1.25rem;
      font-weight: 700;
      color: #333;
      line-height: 1;
    }

    .apt-month {
      font-size: 0.65rem;
      color: #6c757d;
      text-transform: uppercase;
      font-weight: 600;
    }
  }

  .apt-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .apt-time,
    .apt-physio,
    .apt-reason {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.85rem;
      color: #555;

      i {
        color: #6c757d;
        font-size: 0.9rem;
        width: 27px;
      }
    }

    .apt-time {
      font-weight: 600;
      color: #333;
    }

    .apt-reason {
      font-style: italic;
      color: #6c757d;
    }
  }

  .apt-status-badge {
    .status-badge {
      display: inline-block;
      padding: 4px 10px;
      border-radius: 10px;
      font-size: 0.7rem;
      font-weight: 600;
      text-transform: capitalize;

      &.confirmed,
      &.booked {
        background: #d4edda;
        color: #155724;
      }

      &.pending {
        background: #fff3cd;
        color: #856404;
      }

      &.cancelled {
        background: #f8d7da;
        color: #721c24;
      }
    }
  }
}

@media (max-width: 576px) {
  .physio-appointments-section {
    .physio-appointments-header {
      flex-direction: column;
      gap: 0.75rem;
      align-items: flex-start;
    }

    .physio-appointment-card {
      flex-wrap: wrap;
    }

    .apt-status-badge {
      width: 100%;
      margin-top: 0.5rem;
    }
  }
}

// ============================================
// Injury Modal Redesigned Styles
// ============================================
.injury-modal-content {
  padding: 0;
}

// Player Header Card
.player-header-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem;
  background: #adc4db;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  color: white;
}

.player-profile-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.player-avatar-lg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.player-avatar-placeholder-lg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.player-info-section {
  .player-name-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .player-team-subtitle {
    margin: 0.25rem 0 0;
    opacity: 0.85;
    font-size: 0.95rem;
  }
}

.status-badges-section {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-badge-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 0.85rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);

  i {
    font-size: 0.9rem;
  }

  &.status-danger {
    background: rgba(220, 53, 69, 0.9);
  }

  &.status-warning {
    background: rgba(255, 193, 7, 0.9);
    color: #212529;
  }

  &.status-success {
    background: rgba(40, 167, 69, 0.9);
  }

  &.status-recovered {
    background: rgba(40, 167, 69, 0.9);
  }

  &.status-treating {
    background: rgba(253, 126, 20, 0.9);
  }
}

// Section Title
.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 1rem;

  i {
    color: #007bff;
    font-size: 1.2rem;
  }
}

// Injury Details Section
.injury-details-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.detail-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  .detail-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      color: #1976d2;
      font-size: 1rem;
    }
  }

  .detail-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;

    .detail-label {
      font-size: 0.75rem;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    .detail-value {
      font-size: 0.95rem;
      font-weight: 500;
      color: #333;
      word-break: break-word;
    }
  }
}

.text-details-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.text-detail-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #e9ecef;

  h5 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: #495057;
    margin: 0 0 0.75rem;

    i {
      color: #6c757d;
    }
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    color: #555;
    line-height: 1.6;
    white-space: pre-wrap;
  }
}

// Documents Section
.documents-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
}

.documents-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.document-upload-area {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  border: 2px dashed #dee2e6;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.document-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  .doc-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #e8f5e9;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      color: #43a047;
      font-size: 1.1rem;
    }
  }

  .doc-info {
    flex: 1;
    min-width: 0;

    .doc-name {
      font-size: 0.9rem;
      font-weight: 500;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }
  }

  .doc-actions {
    display: flex;
    gap: 0.5rem;
  }

  .doc-action-btn {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    text-decoration: none;

    &.view {
      background: #e3f2fd;
      color: #1976d2;

      &:hover {
        background: #bbdefb;
      }
    }

    &.delete {
      background: #ffebee;
      color: #c62828;

      &:hover {
        background: #ffcdd2;
      }
    }

    i {
      font-size: 0.9rem;
    }
  }
}

.empty-documents {
  text-align: center;
  padding: 2rem;
  color: #6c757d;

  i {
    font-size: 2.5rem;
    opacity: 0.4;
    margin-bottom: 0.5rem;
    display: block;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

// Modal Actions
.modal-actions {
  margin-bottom: 1.5rem;

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
}

// Attendance Section
.attendance-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.25rem;
}

.attendance-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.25rem;

  .attendance-title {
    flex: 1;
    min-width: 200px;

    .section-title {
      margin-bottom: 0.25rem;
    }

    .attendance-description {
      margin: 0;
      font-size: 0.85rem;
      color: #6c757d;
    }
  }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
  }
}

.attendance-content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

// Treatment Records Table
.treatment-records {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9ecef;
}

.treatment-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
  }

  th {
    background: #f8f9fa;
    font-size: 0.8rem;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  td {
    font-size: 0.9rem;
    color: #333;
  }

  tbody tr {
    transition: background 0.15s;

    &:hover {
      background: #f8f9fa;
    }

    &:last-child td {
      border-bottom: none;
    }

    &.recovered-row {
      background: #e8f5e9;

      &:hover {
        background: #c8e6c9;
      }
    }
  }

  .date-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      color: #6c757d;
    }
  }
}

.treatment-status-badge {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;

  &.recovered {
    background: #d4edda;
    color: #155724;
  }

  &.ongoing {
    background: #fff3cd;
    color: #856404;
  }
}

.empty-treatments {
  text-align: center;
  padding: 2.5rem;
  color: #6c757d;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  i {
    font-size: 2.5rem;
    opacity: 0.4;
    margin-bottom: 0.75rem;
    display: block;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

// Treatment Details Panel
.treatment-details-panel {
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  overflow: hidden;

  .panel-header {
    padding: 1rem 1.25rem;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;

    h5 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      color: #333;

      i {
        color: #007bff;
      }
    }
  }

  .panel-body {
    padding: 1.25rem;
  }

  .form-group {
    margin-bottom: 1.25rem;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      font-size: 0.9rem;
      font-weight: 500;
      color: #495057;
    }

    .voice-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      padding: 0.35rem 0.75rem;
      background: #fff5f5;
      border: 1px solid #feb2b2;
      border-radius: 6px;
      color: #c53030;
      font-size: 0.8rem;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #fed7d7;
      }

      .recording {
        color: #e53e3e;
        animation: pulse 1s infinite;
      }
    }

    .form-control,
    .form-select {
      border-radius: 8px;
      border: 1px solid #dee2e6;
      padding: 0.75rem;
      font-size: 0.9rem;

      &:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }

    textarea.form-control {
      resize: vertical;
      min-height: 120px;
    }
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
}

// ============================================
// SIMPLIFIED ADD TREATMENT RECORD MODAL STYLES
// ============================================
.treatment-record-form {
  .injury-context-banner {
    display: flex;
    align-items: center;
    gap: 1rem;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border-radius: 12px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
    border: 1px solid #90caf9;

    .context-icon {
      width: 48px;
      height: 48px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      i {
        font-size: 1.5rem;
        color: #1976d2;
      }
    }

    .context-info {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      .injury-type {
        font-size: 1.1rem;
        font-weight: 600;
        color: #1565c0;
      }

      .injury-date {
        font-size: 0.85rem;
        color: #5c6bc0;
      }
    }
  }

  .form__item {
    margin-bottom: 1.5rem;

    .form__label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      font-size: 0.95rem;
      font-weight: 600;
      color: #333;

      i {
        color: #6c757d;
      }
    }

    .voice-record-button {
      float: right;
      margin-bottom: 0.5rem;
    }

    .form-control,
    .form-select {
      border-radius: 10px;
      border: 1px solid #dee2e6;
      padding: 0.875rem 1rem;
      font-size: 0.95rem;
      transition: all 0.2s;

      &:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
      }
    }

    textarea.form-control {
      resize: vertical;
      min-height: 150px;
      line-height: 1.6;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 1rem;
    border-top: 1px solid #e9ecef;
    margin-top: 0.5rem;

    .btn {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.65rem 1.25rem;
      font-weight: 500;
      border-radius: 8px;
    }

    .btn-success {
      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
      border: none;

      &:hover:not(:disabled) {
        background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 576px) {
  .treatment-record-form {
    .injury-context-banner {
      flex-direction: column;
      text-align: center;
    }

    .form-actions {
      flex-direction: column-reverse;

      .btn {
        width: 100%;
        justify-content: center;
      }
    }
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

// Responsive for Injury Modal
@media (max-width: 768px) {
  .player-header-card {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  .status-badges-section {
    width: 100%;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }

  .attendance-header {
    flex-direction: column;

    .btn {
      width: 100%;
      justify-content: center;
    }
  }

  .treatment-records {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .treatment-table {
    font-size: 0.85rem;
    min-width: 100%;

    th,
    td {
      padding: 0.5rem 0.5rem;
      white-space: nowrap;
    }

    // Make Status column more compact on mobile
    .treatment-status-badge {
      padding: 0.2rem 0.4rem;
      font-size: 0.7rem;
    }

    // Compact date cell
    .date-cell {
      gap: 0.25rem;

      i {
        display: none; // Hide calendar icon on mobile to save space
      }
    }
  }
}

/* ============================================
   IMPROVED INJURY SECTION STYLES
   ============================================ */

.injury-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  overflow: hidden;
  border: 1px solid #e9ecef;

  &.live-injuries {
    border-left: 4px solid #dc3545;
  }

  &.historic-injuries {
    border-left: 4px solid #6c757d;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: linear-gradient(to right, #f8f9fa, #fff);
  border-bottom: 1px solid #e9ecef;

  .header-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i {
      font-size: 1.5rem;
      color: #6c757d;
    }

    h3 {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      color: #212529;
    }
  }

  .season-label {
    font-size: 0.875rem;
    color: #6c757d;
    background: #e9ecef;
    padding: 0.35rem 0.75rem;
    border-radius: 20px;
    font-weight: 500;
  }
}

.live-injuries .section-header {
  .header-title i {
    color: #dc3545;
  }
}

.historic-injuries .section-header {
  .header-title i {
    color: #6c757d;
  }
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;

  &.danger {
    background: #dc3545;
    color: white;
  }

  &.muted {
    background: #6c757d;
    color: white;
  }

  &.success {
    background: #28a745;
    color: white;
  }
}

.injury-table-wrapper {
  padding: 1rem 1.5rem 1.5rem;
  overflow-x: auto;
}

.injury-table.modern {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  thead {
    th {
      background: #f8f9fa;
      padding: 1rem;
      font-weight: 600;
      color: #495057;
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 0.5px;
      border-bottom: 2px solid #dee2e6;
      white-space: nowrap;

      &:first-child {
        border-radius: 8px 0 0 0;
      }

      &:last-child {
        border-radius: 0 8px 0 0;
      }
    }
  }

  tbody {
    tr {
      transition: background-color 0.15s ease;

      &:hover {
        background-color: #f8f9fa;
      }

      &:not(:last-child) td {
        border-bottom: 1px solid #e9ecef;
      }

      &.full-recoverd {
        background-color: #d4edda;

        &:hover {
          background-color: #c3e6cb;
        }
      }
    }

    td {
      padding: 1rem;
      vertical-align: middle;
      color: #212529;
    }
  }

  .injury-status {
    span {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 6px;
      font-weight: 500;
      font-size: 0.875rem;

      i {
        font-size: 1rem;
      }
    }

    .recovering {
      background: linear-gradient(135deg, #fff3cd, #ffeeba);
      color: #856404;
      border: 1px solid #ffc107;
    }

    .full-recoverd,
    .success {
      background: linear-gradient(135deg, #d4edda, #c3e6cb);
      color: #155724;
      border: 1px solid #28a745;
    }

    .warning {
      background: linear-gradient(135deg, #f8d7da, #f5c6cb);
      color: #721c24;
      border: 1px solid #dc3545;
    }

    .info {
      background: linear-gradient(135deg, #d1ecf1, #bee5eb);
      color: #0c5460;
      border: 1px solid #17a2b8;
    }

    .primary {
      background: linear-gradient(135deg, #cce5ff, #b8daff);
      color: #004085;
      border: 1px solid #007bff;
    }
  }

  .playing-training-status {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    margin-right: 0.5rem;
    margin-bottom: 0.25rem;

    &.text-danger {
      background: #fb4b5a;
    }

    &.text-success {
      background: #4af973;
    }

    &.text-warning {
      background: #ffd23d;
      color: #423202 !important;
    }
  }

  .buttons-wrapper {
    display: flex;
    gap: 0.5rem;
    flex-wrap: nowrap;

    button {
      padding: 0.5rem 0.75rem;
      font-size: 0.8rem;
      border-radius: 6px;
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      white-space: nowrap;
    }
  }
}

/* Empty State Card */
.empty-state-card {
  text-align: center;
  padding: 3rem 2rem;
  margin: 1rem 1.5rem 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #dee2e6;

  .empty-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;

    i {
      font-size: 2rem;
    }

    &.success {
      background: #d4edda;
      color: #28a745;
    }

    &.muted {
      background: #e9ecef;
      color: #6c757d;
    }

    &.danger {
      background: #f8d7da;
      color: #dc3545;
    }
  }

  h4 {
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
  }

  p {
    margin: 0;
    color: #6c757d;
    font-size: 0.9rem;
  }
}

/* Injury Summary Section */
.injury-summary-section {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  margin-top: 1rem;
}

.injury-type-summary {
  flex: 1;
  min-width: 250px;
  background: white;
  border-radius: 10px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  h4 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0 0 1rem;
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e9ecef;

    i {
      color: #007bff;
    }
  }
}

.injury-type-list {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0;
    border-bottom: 1px dashed #e9ecef;

    &:last-child {
      border-bottom: none;
    }
  }

  .injury-type-name {
    color: #495057;
    font-size: 0.9rem;
    text-transform: capitalize;
  }

  .injury-type-count {
    background: #e9ecef;
    color: #495057;
    font-weight: 600;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.85rem;
    min-width: 32px;
    text-align: center;
  }
}

/* Desktop/Mobile visibility */
.injury-content {
  .desktop-only {
    display: block !important;
  }

  .mobile-only {
    display: none !important;
  }
}

/* Mobile Card Styles */
.injury-cards-wrapper {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.injury-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  &.recovered {
    border-left: 4px solid #28a745;
    background: linear-gradient(to right, #f0fff4, white);
  }

  &.historic {
    border-left: 4px solid #6c757d;
  }
}

.injury-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;

  .injury-type-badge {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    color: #212529;
    font-size: 1rem;

    i {
      color: #dc3545;
      font-size: 1.1rem;
    }
  }

  .status-pill {
    padding: 0.35rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;

    &.recovering {
      background: #fff3cd;
      color: #856404;
    }

    &.full-recoverd,
    &.success {
      background: #d4edda;
      color: #155724;
    }

    &.warning {
      background: #f8d7da;
      color: #721c24;
    }

    &.info {
      background: #d1ecf1;
      color: #0c5460;
    }
  }
}

.historic .injury-card-header .injury-type-badge i {
  color: #6c757d;
}

.injury-card-body {
  padding: 1rem;
}

.injury-info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  .info-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .info-label {
    font-size: 0.75rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 0.35rem;

    i {
      font-size: 0.85rem;
    }
  }

  .info-value {
    font-size: 0.95rem;
    font-weight: 500;
    color: #212529;
  }
}

.status-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;

  i {
    font-size: 0.9rem;
  }

  &.success {
    background: #d4edda;
    color: #155724;
  }

  &.danger {
    background: #f8d7da;
    color: #721c24;
  }

  &.warning {
    background: #fff3cd;
    color: #856404;
  }
}

.rtp-badge-mobile {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #e9ecef;

  .badge {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
  }
}

.injury-card-actions {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  flex-wrap: wrap;

  .action-btn {
    flex: 1;
    min-width: 80px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    padding: 0.6rem 0.75rem;
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.2s;

    i {
      font-size: 1rem;
    }

    &.primary {
      background: #007bff;
      color: white;

      &:hover {
        background: #0056b3;
      }
    }

    &.info {
      background: #17a2b8;
      color: white;

      &:hover {
        background: #138496;
      }
    }

    &.warning {
      background: #ffc107;
      color: #212529;

      &:hover {
        background: #e0a800;
      }
    }

    &.danger {
      background: #dc3545;
      color: white;
      flex: 0;
      min-width: 48px;

      &:hover {
        background: #c82333;
      }
    }
  }
}

/* Responsive adjustments for injury sections */
@media (max-width: 992px) {
  .injury-table.modern {
    .buttons-wrapper {
      flex-direction: column;

      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
}

@media (max-width: 768px) {
  .injury-content {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: block !important;
    }
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;

    .header-title {
      h3 {
        font-size: 1.1rem;
      }

      i {
        font-size: 1.25rem;
      }
    }

    .season-label {
      align-self: flex-start;
      font-size: 0.8rem;
    }
  }

  .injury-content {
    padding: 0;
  }

  .injury-summary-section {
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }

  .injury-type-summary {
    min-width: unset;
  }

  .empty-state-card {
    padding: 2rem 1rem;
    margin: 0.75rem;

    .empty-icon {
      width: 56px;
      height: 56px;

      i {
        font-size: 1.75rem;
      }
    }

    h4 {
      font-size: 1rem;
    }
  }
}

@media (max-width: 480px) {
  .injury-info-row {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .injury-card-actions {
    .action-btn {
      font-size: 0.8rem;
      padding: 0.5rem 0.6rem;

      &.danger {
        min-width: 44px;
      }
    }
  }

  .status-tags {
    flex-direction: column;
  }

  .status-tag {
    width: 100%;
    justify-content: center;
  }
}
</style>
